
import {
    AlertTriangle, Apple, BadgePercent, Banknote, BookOpen, CircleCheckBig, CircleX, Clock, CreditCard, Flame, Gift, Info, MousePointerClick, PawPrint, ReceiptText, Scissors, ShoppingBag, Sparkles, Star, TicketPercent, ToyBrick, TrendingUp, Users, Wallet, WalletCards,
    ShoppingCart,
    HeartHandshake,
    RotateCcw,
    RefreshCw,
    Eye,
    Search,
    PackageCheck,
    Gamepad2,
    Trophy,
    Joystick,
    Handshake,
    Moon,
    EyeOff,
    User,
    Bed,
    Bell,
    Flower2,
    ShieldCheck,
    Swords,
    Laugh,
    MapPinned,
    BadgeCheck,
    Compass,
    Link,
    VolumeX,
    CircleSlash,
    GraduationCap,
    Sun,
    Dog,
} from "lucide-react";
import { ImagePath } from "../../assests";
import { BannerItem, CarouselItem, Category, CustomerOrderType, ICustomerOrder, ImageItem, MenuItem, PetItems, Section } from "./CustomerTypes";
import { Option } from "../../components/customer/Dropdown";
import { Smile, Heart, Zap, Brain, Volume2, Shield } from "lucide-react";
import { Column } from "../../components/PricingTable";
import { Activity } from "react";
import { SectionCard } from "./AdminTypes";
import { SectionData } from "../../types/Response/CustomerResponse";

export const carouselData: CarouselItem[] = [
    {
        id: 1,
        type: "image_only",
        image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=1200&q=80",
        kicker: "Premium Pet Food",
        title: "Nourish them like ",
        titleAccent: "family",
        description: "because they are",
    },
    {
        id: 2,
        type: "image_left",
        image: "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=800&q=80",
        kicker: "Grooming & Salon",
        title: "A fresh look for your ",
        titleAccent: "little one",
        description:
            "Expert grooming, spa baths, and styling — tailored for every breed. Your pet deserves to feel their absolute best.",
        buttonText: "Book a Session",
    },
    {
        id: 3,
        type: "image_right",
        image: "https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?w=800&q=80",
        kicker: "Pet Products",
        title: "Everything they ",
        titleAccent: "love & need",
        description:
            "From cozy beds to playful toys and health essentials — shop our handpicked collection built with love for your pet.",
        buttonText: "Shop Now",
    },
];

export const CarouselImages: SectionData[] = [
    {
        id: 1,
        src: ImagePath.backgroundImageMain,
        type: "image"
    },
    {
        id: 2,
        src: ImagePath.backgroundImageThreeMain,
        type: "image"
    },
]

export const petCarouselImages: SectionData[] = [
    {
        id: 1,
        src: ImagePath.grommingbanner3,
        type: "image",
    },
    {
        id: 2,
        src: ImagePath.Adbanner,
        type: "image",
    },
];

export const serviceCarouselImages: SectionData[] = [
    {
        id: 1,
        src: ImagePath.grommingbanner1,
        type: "image",
    },
    {
        id: 2,
        src: ImagePath.grommingbanner2,
        type: "image",
    },
];


export const categories = [
    {
        label: "Dog",
        subCategories: [
            {
                title: "Food",
                items: [
                    "Dry Food",
                    "Wet Food",
                    "Fresh Food",
                    "Milk Replacers",
                    "Food Toppers & Mixers",
                ],
            },
            {
                title: "Treats",
                items: [
                    "Training Treats",
                    "Dental Treats",
                    "Functional Treats",
                    "Bones & Natural Chews",
                    "Freeze & Air Dried Treats",
                    "Ice Cream",
                    "Biscuits & Baked Treats",
                    "Soft & Chewy Treats",
                    "Jerky Treats",
                    "Grain-Free",
                ],
            },
            {
                title: "Walk & Travel Essentials",
                items: [
                    "Travel Carriers & Crates",
                    "Leashes & Leads",
                    "Collars",
                    "Harnesses",
                    "Charms & ID Tags",
                    "Pee Pads & Diapers",
                    "Poop Bags & Dispensers",
                    "Strollers",
                    "Car & Bicycle Accessories",
                    "Travel Blankets & Mats",
                ],
            },
            {
                title: "Beds",
                items: [
                    "Bolster & Basket Beds",
                    "Cushion Beds",
                    "Orthopedic Beds",
                    "Cave Beds",
                    "Pillows & Cushions",
                    "Lying & Cooling Mats",
                    "Blankets",
                ],
            },
            {
                title: "Supplies",
                items: [
                    "Pet Technology",
                    "Toys",
                    "Bowls & Feeders",
                    "Cleaning & Potty",
                    "Crates, Pens & Gates",
                    "Training & Behavior",
                    "Clothing & Accessories",
                    "Gifts & Home",
                ],
            },
            {
                title: "Health & Wellness",
                items: [
                    "Hip & Joint Care",
                    "Digestive Care",
                    "Dental Care",
                    "Stress & Anxiety",
                    "Multivitamins & Supplements",
                    "Flea & Tick",
                    "Skin & Coat Care",
                    "First Aid & Recovery",
                    "Paw & Nose Care",
                    "Urinary & Kidney Health",
                ],
            },
            {
                title: "Grooming & Hygiene",
                items: [
                    "Shampoos",
                    "Conditioners",
                    "Wipes",
                    "Dental Care",
                    "Ear Care",
                    "Eye Care",
                    "Grooming Tools",
                    "Paw & Claws Care",
                    "Brushes & Combs",
                    "Perfumes & Deodorizers",
                ],
            },
        ],
    },
    {
        label: "Puppy",
        subCategories: [
            {
                title: "Food",
                items: [
                    "Dry Food",
                    "Wet Food",
                    "Fresh Food",
                    "Milk Replacers",
                    "Food Toppers & Mixers",
                ],
            },
            {
                title: "Treats",
                items: [
                    "Training Treats",
                    "Dental Treats",
                    "Functional Treats",
                    "Bones & Natural Chews",
                    "Freeze & Air Dried Treats",
                    "Ice Cream",
                    "Biscuits & Baked Treats",
                    "Soft & Chewy Treats",
                    "Jerky Treats",
                    "Grain-Free",
                ],
            },
            {
                title: "Walk & Travel Essentials",
                items: [
                    "Travel Carriers & Crates",
                    "Leashes & Leads",
                    "Collars",
                    "Harnesses",
                    "Charms & ID Tags",
                    "Pee Pads & Diapers",
                    "Poop Bags & Dispensers",
                    "Strollers",
                    "Car & Bicycle Accessories",
                    "Travel Blankets & Mats",
                ],
            },
            {
                title: "Beds",
                items: [
                    "Bolster & Basket Beds",
                    "Cushion Beds",
                    "Orthopedic Beds",
                    "Cave Beds",
                    "Pillows & Cushions",
                    "Lying & Cooling Mats",
                    "Blankets",
                ],
            },
            {
                title: "Supplies",
                items: [
                    "Pet Technology",
                    "Toys",
                    "Bowls & Feeders",
                    "Cleaning & Potty",
                    "Crates, Pens & Gates",
                    "Training & Behavior",
                    "Clothing & Accessories",
                    "Gifts & Home",
                ],
            },
            {
                title: "Health & Wellness",
                items: [
                    "Hip & Joint Care",
                    "Digestive Care",
                    "Dental Care",
                    "Stress & Anxiety",
                    "Multivitamins & Supplements",
                    "Flea & Tick",
                    "Skin & Coat Care",
                    "First Aid & Recovery",
                    "Paw & Nose Care",
                    "Urinary & Kidney Health",
                ],
            },
            {
                title: "Grooming & Hygiene",
                items: [
                    "Shampoos",
                    "Conditioners",
                    "Wipes",
                    "Dental Care",
                    "Ear Care",
                    "Eye Care",
                    "Grooming Tools",
                    "Paw & Claws Care",
                    "Brushes & Combs",
                    "Perfumes & Deodorizers",
                ],
            },
        ],
    },
    {
        label: "Cat",
        subCategories: [
            {
                title: "Food",
                items: [
                    "Dry Food",
                    "Wet Food",
                    "Food Toppers",
                    "Air-Dried Food",
                    "Milk Replacers",
                    "Discovery Packs",
                    "Fresh Cooked Food",
                    "Raw & Freeze-Dried Food",
                ],
            },
            {
                title: "Litter & Accessories",
                items: [
                    "Litter",
                    "Litter Boxes",
                    "Litter Box Accessories",
                ],
            },
            {
                title: "Treats",
                items: [
                    "Lickable Treats",
                    "Freeze & Air Dried Treats",
                    "Crunchy Treats",
                    "Functional Treats",
                    "Soft & Chewy Treats",
                    "Catnip & Grass Treats",
                    "Training Treats",
                    "Dental Treats",
                ],
            },
            {
                title: "Supplies",
                items: [
                    "Pet Technology",
                    "Toys",
                    "Healthcare",
                    "Trees, Condos & Scratchers",
                    "Travel Carriers & Crates",
                    "Bowls & Feeders",
                    "Crates, Pens & Gates",
                    "Grooming",
                    "Beds",
                    "Leashes, Collar & Harnesses",
                ],
            },
            {
                title: "Healthcare",
                items: [
                    "Stress & Anxiety",
                    "Flea & Tick",
                    "Skin & Coat Care",
                    "Dental Care",
                    "Dewormers",
                    "First Aid & Recovery",
                    "Milk Replacers",
                    "Multivitamins",
                    "Digestive Care",
                    "Hairball Control",
                ],
            },
        ],
    },
    {
        label: "Kitten",
        subCategories: [
            {
                title: "Food",
                items: [
                    "Dry Food",
                    "Wet Food",
                    "Food Toppers",
                    "Air-Dried Food",
                    "Milk Replacers",
                    "Discovery Packs",
                    "Fresh Cooked Food",
                    "Raw & Freeze-Dried Food",
                ],
            },
            {
                title: "Litter & Accessories",
                items: [
                    "Litter",
                    "Litter Boxes",
                    "Litter Box Accessories",
                ],
            },
            {
                title: "Treats",
                items: [
                    "Lickable Treats",
                    "Freeze & Air Dried Treats",
                    "Crunchy Treats",
                    "Functional Treats",
                    "Soft & Chewy Treats",
                    "Catnip & Grass Treats",
                    "Training Treats",
                    "Dental Treats",
                ],
            },
            {
                title: "Supplies",
                items: [
                    "Pet Technology",
                    "Toys",
                    "Healthcare",
                    "Trees, Condos & Scratchers",
                    "Travel Carriers & Crates",
                    "Bowls & Feeders",
                    "Crates, Pens & Gates",
                    "Grooming",
                    "Beds",
                    "Leashes, Collar & Harnesses",
                ],
            },
            {
                title: "Healthcare",
                items: [
                    "Stress & Anxiety",
                    "Flea & Tick",
                    "Skin & Coat Care",
                    "Dental Care",
                    "Dewormers",
                    "First Aid & Recovery",
                    "Milk Replacers",
                    "Multivitamins",
                    "Digestive Care",
                    "Hairball Control",
                ],
            },
        ],
    },
    {
        label: "New Arrivals",
        icon: Sparkles,
        highlight: true,
    },
    {
        label: "Special Offer",
        icon: Sparkles,
        highlight: true,
    },

];

export const petsCategories = [
    {
        label: "Dog",
        subCategories: [
            {
                title: "Adopt a Dog",
                items: [
                    "Adult Dogs",
                    "Senior Dogs",
                    "Rescue Dogs",
                    "Special Needs Dogs",
                    "Bonded Pairs",
                ],
            },
            {
                title: "Dog Breeds",
                items: [
                    "Labrador",
                    "Golden Retriever",
                    "German Shepherd",
                    "Beagle",
                    "Pug",
                    "Shih Tzu",
                    "Husky",
                    "Indie Dogs",
                ],
            },
            {
                title: "Age",
                items: [
                    "1-3 Years",
                    "3-7 Years",
                    "Senior Dogs",
                ],
            },
            {
                title: "Gender",
                items: [
                    "Male Dogs",
                    "Female Dogs",
                ],
            },
            {
                title: "Personality",
                items: [
                    "Friendly",
                    "Playful",
                    "Calm",
                    "Active",
                    "Protective",
                    "Good With Kids",
                    "Good With Pets",
                ],
            },
        ],
    },
    {
        label: "Puppy",
        subCategories: [
            {
                title: "Adopt a Dog",
                items: [
                    "Puppies",
                    "Adult Dogs",
                    "Senior Dogs",
                    "Rescue Dogs",
                    "Special Needs Dogs",
                    "Bonded Pairs",
                ],
            },
            {
                title: "Dog Breeds",
                items: [
                    "Labrador",
                    "Golden Retriever",
                    "German Shepherd",
                    "Beagle",
                    "Pug",
                    "Shih Tzu",
                    "Husky",
                    "Indie Dogs",
                ],
            },
            {
                title: "Age",
                items: [
                    "0-3 Months",
                    "3-6 Months",
                    "6-12 Months",
                ],
            },
            {
                title: "Gender",
                items: [
                    "Male Dogs",
                    "Female Dogs",
                ],
            },
            {
                title: "Personality",
                items: [
                    "Friendly",
                    "Playful",
                    "Calm",
                    "Active",
                    "Protective",
                    "Good With Kids",
                    "Good With Pets",
                ],
            },
        ],
    },
    {
        label: "Cat",
        subCategories: [
            {
                title: "Adopt a Cat",
                items: [
                    "Adult Cats",
                    "Senior Cats",
                    "Rescue Cats",
                    "Special Needs Cats",
                    "Bonded Pairs",
                ],
            },
            {
                title: "Cat Breeds",
                items: [
                    "Persian",
                    "Siamese",
                    "Maine Coon",
                    "British Shorthair",
                    "Bengal",
                    "Ragdoll",
                    "Indian Billi",
                    "Scottish Fold",
                ],
            },
            {
                title: "Size",
                items: [
                    "Small Cats",
                    "Medium Cats",
                    "Large Cats",
                ],
            },
            {
                title: "Age",
                items: [
                    "1-3 Years",
                    "3-7 Years",
                    "Senior Cats",
                ],
            },
            {
                title: "Gender",
                items: [
                    "Male Cats",
                    "Female Cats",
                ],
            },
            {
                title: "Personality",
                items: [
                    "Playful",
                    "Calm",
                    "Friendly",
                    "Independent",
                    "Affectionate",
                    "Indoor Friendly",
                    "Good With Pets",
                ],
            },
        ],
    },
    {
        label: "Kitten",
        subCategories: [
            {
                title: "Adopt a Cat",
                items: [
                    "Kittens",
                    "Adult Cats",
                    "Senior Cats",
                    "Rescue Cats",
                    "Special Needs Cats",
                    "Bonded Pairs",
                ],
            },
            {
                title: "Cat Breeds",
                items: [
                    "Persian",
                    "Siamese",
                    "Maine Coon",
                    "British Shorthair",
                    "Bengal",
                    "Ragdoll",
                    "Indian Billi",
                    "Scottish Fold",
                ],
            },
            {
                title: "Size",
                items: [
                    "Small Cats",
                    "Medium Cats",
                    "Large Cats",
                ],
            },
            {
                title: "Age",
                items: [
                    "0-3 Months",
                    "3-6 Months",
                    "6-12 Months",
                ],
            },
            {
                title: "Gender",
                items: [
                    "Male Cats",
                    "Female Cats",
                ],
            },
            {
                title: "Personality",
                items: [
                    "Playful",
                    "Calm",
                    "Friendly",
                    "Independent",
                    "Affectionate",
                    "Indoor Friendly",
                    "Good With Pets",
                ],
            },
        ],
    },
    {
        label: "New Arrivals",
        icon: Sparkles,
        highlight: true,
    },

    {
        label: "Special Offer",
        icon: Sparkles,
        highlight: true,
    },
];

export const servicesCategories = [
    {
        label: "Grooming",
        subCategories: [
            {
                title: "Dog Grooming",
                items: [
                    "Bath & Blow Dry",
                    "Hair Trimming",
                    "Nail Clipping",
                    "Ear Cleaning",
                    "Teeth Cleaning",
                ],
            },
            {
                title: "Cat Grooming",
                items: [
                    "Cat Bathing",
                    "Fur Brushing",
                    "Nail Trimming",
                    "Coat Care",
                ],
            },
        ],
    },

    {
        label: "Training",
        subCategories: [
            {
                title: "Basic Training",
                items: [
                    "Obedience Training",
                    "Puppy Training",
                    "Potty Training",
                    "Leash Training",
                ],
            },
            {
                title: "Advanced Training",
                items: [
                    "Behavior Correction",
                    "Guard Training",
                    "Socialization",
                    "Agility Training",
                ],
            },
        ],
    },

    {
        label: "Pet Taxi",
        subCategories: [
            {
                title: "Transportation",
                items: [
                    "Vet Visits",
                    "Airport Pickup",
                    "Grooming Drop",
                    "Emergency Transport",
                    "Local Pet Travel",
                ],
            },
        ],
    },

    {
        label: "Relocation",
        subCategories: [
            {
                title: "Pet Relocation",
                items: [
                    "Domestic Relocation",
                    "International Relocation",
                    "Documentation Help",
                    "Flight Booking",
                    "Pet Boarding Support",
                ],
            },
        ],
    },

    {
        label: "Vet Clinic",
        subCategories: [
            {
                title: "Medical Services",
                items: [
                    "General Checkup",
                    "Vaccination",
                    "Emergency Care",
                    "Surgery",
                    "Dental Care",
                ],
            },
            {
                title: "Special Care",
                items: [
                    "Skin Treatment",
                    "Orthopedic Care",
                    "Diagnostic Tests",
                    "Deworming",
                ],
            },
        ],
    },
    {
        label: "New Arrivals",
        icon: Sparkles,
        highlight: true,
    },
    {
        label: "Special Offer",
        icon: Sparkles,
        highlight: true,
    },
];

export const maincategories: Category[] = [
    {
        id:4,
        label: "DOG",
        image: "https://png.pngtree.com/png-clipart/20250118/original/pngtree-golden-retriever-dog-pictures-png-image_20183713.png",
        bgColor: "bg-[#EDE3DA]",
    },
    {
          id:140,
        label: "CAT",
        image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/25d45014-8cc3-4c98-b02c-5a0cf3a55ddd/dcopdcg-85a7601e-e7ca-4de8-96d6-28df58309247.png/v1/fill/w_900,h_703/domestic_cat_on_a_transparent_background_by_prussiaart_dcopdcg-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzAzIiwicGF0aCI6Ii9mLzI1ZDQ1MDE0LThjYzMtNGM5OC1iMDJjLTVhMGNmM2E1NWRkZC9kY29wZGNnLTg1YTc2MDFlLWU3Y2EtNGRlOC05NmQ2LTI4ZGY1ODMwOTI0Ny5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.fJA2_zPSu1i9xj2aH3mOsHrbnBI_JEDOQm2oTeMl498",
        bgColor: "bg-[#EFE3B0]",
    },
    {
        label: "AQUATIC",
        image: "https://png.pngtree.com/png-clipart/20240416/original/pngtree-fish-without-background-png-image_14843713.png",
        bgColor: "bg-[#DCE8F0]",
        comingSoon: true
    },
    {
        label: "BIRDS",
        image: "https://static.vecteezy.com/system/resources/previews/059/595/357/non_2x/sun-conure-parrot-isolated-exotic-pet-bird-profile-detailed-plumage-cut-out-transparent-png.png",
        bgColor: "bg-[#DCE6C8]",
        comingSoon: true
    },
    {
        label: "SMALL PETS",
        image: "https://png.pngtree.com/png-vector/20250620/ourmid/pngtree-hamster-isolated-on-a-transparent-background-png-image_16555349.png",
        bgColor: "bg-[#F1DAD0]",
        comingSoon: true
    },
    {
        label: "REPTILE",
        image: "https://png.pngtree.com/png-vector/20240712/ourmid/pngtree-a-reptiles-png-image_13066752.png",
        bgColor: "bg-[#EFE3B0]",
        comingSoon: true
    },
];

export const videoData = [
    {
        id: '1',
        video: "https://petskyonline.com/assets/videos/jerhigh_treat.mp4",
        productName: "Premium Dog Food",
        price: "AED 499",
        image: "https://petskyonline.com/cdn/products/fef06027a19dc1a537f928e62620755e-md.jpg",
    },
    {
        id: '2',
        video: "https://petskyonline.com/assets/videos/remotecontrolvideo.mp4",
        productName: "Cat Toy",
        price: "AED 299",
        image: "https://petskyonline.com/assets/img/banners/remotecontrolimg.png",
    },
    {
        id: '3',
        video: "https://petskyonline.com/assets/videos/snakecatvid.mp4",
        productName: "Cat Toy",
        price: "AED 299",
        image: "https://petskyonline.com/assets/img/banners/snakecatimg.png",
    },
    {
        id: '4',
        video: "https://petskyonline.com/assets/videos/Godogvid.mp4",
        productName: "Dog Toy",
        price: "AED 299",
        image: "https://petskyonline.com/assets/img/banners/godogunicorn.jpg",
    },

];


export const banners: ImageItem[] = [
    { id: '1', src: ImagePath.BannerAd, type: "image" },
    { id: '2', src: "https://petcornerdubai.com/uploads//Banners/Slider%20Banner/Web-15-Snake.gif", type: "image" },
];

export const images = [
    ImagePath.BannerAd,
    ImagePath.BannerAdJPG,
    ImagePath.BannerAdOne,
    ImagePath.BannerAdTwo,
];

export const multibanner: BannerItem[] = [
    { id: '1', src: ImagePath.OffImage, type: "image" },
    { id: '2', src: ImagePath.OffImageTwo, type: "image" },
    { id: '3', src: ImagePath.OffImageThree, type: "image" },
    { id: '4', src: ImagePath.OffImageOne, type: "image" },
];

export const sizes = ["200g", "500g", "1Kg", "2Kg", "3Kg", "5Kg"];

export const toysize = ["S", "M", "L", "XL"]

export const Colors = [
    { id: "1", name: "Red", value: "#FF0000" },
    { id: "2", name: "Purple", value: "#8686df" },
    { id: "3", name: "Green", value: "#41c041" },
    { id: "4", name: "Black", value: "#000000" },
    { id: "5", name: "Yellow", value: "#f5b43d" },
];

export const features = [
    { text: "Selling Fast", icon: Flame, color: "text-red-500" },
    { text: "Only Few Left", icon: AlertTriangle, color: "text-orange-500" },
    { text: "Limited Time Deal", icon: Clock, color: "text-blue-500" },
    { text: "Best Seller", icon: Star, color: "text-yellow-500" },
    { text: "Trending Now", icon: TrendingUp, color: "text-green-600" },
];

export const sections: Section[] = [
    {
        key: "feature",
        title: "Feature & Specs",
        type: "table",
        data: [
            { label: "Pet Toy Type", value: "Exercise Toy" },
            { label: "Breed Recommendation", value: "Small Breeds" },
            { label: "Recommended Uses For Product", value: "Exercise, Playing, Training" },
            { label: "Indoor Outdoor Usage", value: "Indoor" },
            { label: "Additional Features", value: "Interactive, Lightweight, Portable, Rotating, Vibrating" },
            { label: "Dog Breed Size", value: "Small" },
            { label: "Pet Type", value: "Cat" },
        ],
    },
    {
        key: "measurements",
        title: "Measurements",
        type: "table",
        data: [
            { label: "Item Weight", value: "0.6 Kilograms" },
            { label: "Unit Count", value: "1.0 Count" },
            { label: "Item Dimensions (L x W x H)", value: "5L x 5W x 5H centimeters" },
        ],
    },
    {
        key: "additional",
        title: "Additional Details",
        type: "table",
        data: [
            { label: "Material Type", value: "Plastic" },
        ],
    }
];

export const Productsections: Section[] = [
    {
        key: "description",
        title: "Product Description",
        type: "text",
        data: "",
    },
    {
        key: "details",
        title: "Item Details",
        type: "table",
        data: [
            { label: "Flavor", value: "Chicken" },
            { label: "Age Range", value: "Adult" },
            { label: "Texture Variation", value: "Chunk" },
            { label: "Health Feature", value: "Immune Support" },
            { label: "Ingredients", value: "Chicken, Carrot" },
            { label: "Packing Type", value: "Carton" },
            { label: "Breed Recommendation", value: "Golden Retriver, Huskey" },
            { label: "Made in Country", value: "Thailand" },
            { label: "Free From", value: "Allergen-Free" }, ,
            { label: "Manufacturer", value: "Josera" },
            { label: "Eco & Sustainable Feature", value: "Eco Friendly" },
            { label: "Scent Variation", value: "Unscented" },
        ]
    },
    {
        key: "measurements",
        title: "Measurements",
        type: "table",
        data: [
            { label: "Item Weight", value: "0.6 Kilograms" },
            { label: "Unit Count", value: "1.0 Count" },
            { label: "Item Dimensions (L x W x H)", value: "5L x 5W x 5H centimeters" },
        ],
    }
];

export const reviewsData = [
    {
        id: "1",
        name: "Buddy",
        location: "Dubai, UAE",
        image: "https://images.dog.ceo/breeds/retriever-golden/n02099601_3004.jpg",
        rating: 5,
        review:
            "Woof! This is paws-down the best meal I've ever had. Bowl cleaned in seconds! I usually take my time eating, but with this food I just can’t stop. The smell is amazing and the taste is even better. My human is happy because I’m eating well, and I’m happy because it’s delicious!",
    },
    {
        id: "2",
        name: "Rocky",
        location: "Abu Dhabi, UAE",
        image: "https://images.dog.ceo/breeds/husky/n02110185_1469.jpg",
        rating: 5,
        review:
            "Even after a long walk, this gives me all the energy I need. Super tasty! I feel active and playful throughout the day. My coat also feels shinier and healthier. Definitely one of the best meals I’ve ever had, I look forward to it every single day!",
    },
    {
        id: "3",
        name: "Max",
        location: "Sharjah, UAE",
        image: "https://images.dog.ceo/breeds/retriever-golden/n02099601_3004.jpg",
        rating: 4,
        review:
            "Love the flavor! My tail starts wagging the moment I smell it. The texture is just perfect and easy to chew. I’ve tried many foods before, but this one really stands out. I just wish I got a slightly bigger portion because I finish it so fast!",
    },
    {
        id: "4",
        name: "Bella",
        location: "Dubai Marina, UAE",
        image: "https://images.dog.ceo/breeds/retriever-golden/n02099601_3004.jpg",
        rating: 5,
        review:
            "Healthy AND delicious? My human finally got it right! I feel lighter, more energetic, and super happy after meals. No tummy issues at all, and I enjoy every bite. It’s like a perfect balance of taste and nutrition made just for me!",
    },
    {
        id: "5",
        name: "Charlie",
        location: "Ajman, UAE",
        image: "https://images.dog.ceo/breeds/beagle/n02088364_11136.jpg",
        rating: 4,
        review:
            "Sniffed it… tasted it… finished it. Approved ✅ The aroma caught my attention instantly, and the taste sealed the deal. I usually get distracted while eating, but not with this one. It keeps me focused until the bowl is empty!",
    },
    {
        id: "6",
        name: "Cooper",
        location: "Al Ain, UAE",
        image: "https://images.dog.ceo/breeds/retriever-golden/n02099601_3004.jpg",
        rating: 5,
        review:
            "I sit. I stay. I wait. But for THIS food? I can’t wait 😆 The moment I see my bowl, I get super excited. It’s filling, tasty, and keeps me satisfied for hours. Honestly, I’d recommend this to every furry friend out there!",
    },

    {
        id: "7",
        name: "Luna",
        location: "Dubai, UAE",
        image: "https://images.dog.ceo/breeds/husky/n02110185_1469.jpg",
        rating: 5,
        review:
            "This is my absolute favorite meal! The moment my human opens the packet, I come running. The taste is rich and satisfying, and I always lick my bowl clean. It keeps me energetic, playful, and super happy throughout the day!",
    },
    {
        id: "8",
        name: "Simba",
        location: "Sharjah, UAE",
        image: "https://images.dog.ceo/breeds/retriever-golden/n02099601_3004.jpg",
        rating: 4,
        review:
            "Really tasty and filling! I enjoy every bite and feel full for a long time. My energy levels have improved and I feel more active during playtime. Definitely something I’d want in my bowl every single day!",
    },
    {
        id: "9",
        name: "Daisy",
        location: "Abu Dhabi, UAE",
        image: "https://images.dog.ceo/breeds/poodle-standard/n02113799_2280.jpg",
        rating: 5,
        review:
            "Finally found something I never get bored of! The taste is consistent and delicious every time. My digestion has improved and I feel healthier overall. My human says I look happier too, and I totally agree!",
    },
    {
        id: "10",
        name: "Bruno",
        location: "Dubai Silicon Oasis, UAE",
        image: "https://images.dog.ceo/breeds/poodle-standard/n02113799_2280.jpg",
        rating: 5,
        review:
            "Strong, tasty, and super satisfying! After eating this, I feel full and ready for all my zoomies. The flavor is amazing and I never leave anything behind. This is definitely premium quality food!",
    },
];

export const shapeBgs = [
    "bg-amber-500",
    "bg-pink-500",
    "bg-sky-500",
    "bg-emerald-500",
    "bg-violet-500",
    "bg-orange-500",
];

export const shapeBorders = [
    "border-amber-300",
    "border-pink-300",
    "border-sky-300",
    "border-emerald-300",
    "border-violet-300",
    "border-orange-300",
];

export const shapeRounded = [
    "rounded-[40%_60%_60%_40%/50%_50%_50%_50%]",
    "rounded-[60%_40%_30%_70%/40%_60%_70%_30%]",
    "rounded-[50%_50%_70%_30%/40%_60%_40%_60%]",
    "rounded-[30%_70%_50%_50%/60%_40%_60%_40%]",
    "rounded-[65%_35%_45%_55%/55%_45%_35%_65%]",
    "rounded-[45%_55%_35%_65%/35%_65%_55%_45%]",
];

export const FooterData = [
    { id: '1', value: 'Careers' },
    { id: '2', value: 'Blog' },
    { id: '3', value: 'Contact Us' },
    { id: '4', value: 'FAQ' },
]

export const pageTypeOptions = [
    { id: "1", label: "About Us" },
    { id: "2", label: "Privacy Policy" },
    { id: "3", label: "Terms & Conditions" },
    { id: "4", label: "Return & Exchange Policy" },
    { id: "5", label: "Cancellation Policy" },
    { id: "6", label: "Shipping Policy" },
];

export const FooterServicesData = [
    { id: '1', value: 'Pet Grooming Services' },
    { id: '2', value: 'Pet Training Services' },
    { id: '3', value: 'Pet Taxi' },
    { id: '5', value: 'Vet Clinic' },
]

export const brands = [
    {
        id: "1",
        name: "Smudges",
        offer: "Free Goodies",
        image: "https://sniffynose.com/_next/static/media/acana.7ad8bf68.webp",
        mainImage: ImagePath.BannerAd
    },
    {
        id: "2",
        name: "Inaba",
        offer: "Upto 18% OFF",
        image: "https://sniffynose.com/_next/static/media/royalCanin.073060c3.webp",
        mainImage: ImagePath.BannerAd
    }, {
        id: "3",
        name: "Acana",
        offer: "Free Goodies",
        image: "https://sniffynose.com/_next/static/media/chipChop.263d5c06.webp",
        mainImage: ImagePath.BannerAd
    },
    {
        id: "4",
        name: "Royal Canin",
        offer: "Upto 18% OFF",
        image: "https://sniffynose.com/_next/static/media/furlicks.93c5c6be.webp",
        mainImage: ImagePath.BannerAd
    },
    {
        id: "5",
        name: "Acana",
        offer: "Free Goodies",
        image: "https://sniffynose.com/_next/static/media/Jerhigh.bdc68ec3.webp",
        mainImage: ImagePath.BannerAd
    },
    {
        id: "6",
        name: "Royal Canin",
        offer: "Upto 18% OFF",
        image: "https://sniffynose.com/_next/static/media/Wahl.585d569c.webp",
        mainImage: ImagePath.BannerAd
    },
]


export const curatedItems = [
    {
        id: "1",
        title: "Pet Food",
        image: "https://images.unsplash.com/photo-1714068691210-073dc52c6c1d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZG9nJTIwZm9vZHxlbnwwfHwwfHx8MA%3D%3D&fm=webp",
    },
    {
        id: "2",
        title: "Toys",
        image: "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8",
    },
    {
        id: "3",
        title: "Clothes",
        image: "https://images.unsplash.com/photo-1583511655826-05700d52f4d9",
    },
    {
        id: "4",
        title: "Grooming Products",
        image: "https://images.unsplash.com/photo-1558788353-f76d92427f16",
    },
    {
        id: "6",
        title: "Accessories",
        image: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e",
    },
    {
        id: "7",
        title: "Healthcare",
        image: "https://images.unsplash.com/photo-1576201836106-db1758fd1c97",
    },
    {
        id: "8",
        title: "Beds",
        image: "https://images.unsplash.com/photo-1515444714064-a0b5721ca5f7",
    },

    // ✅ NEW ADDED

    {
        id: "9",
        title: "Shampoo & Bath",
        image: "https://images.unsplash.com/photo-1601758003122-53c40e686a19",
    },
    {
        id: "11",
        title: "Leashes & Collars",
        image: "https://images.unsplash.com/photo-1576201836106-db1758fd1c97",
    },
    {
        id: "15",
        title: "Cleaning & Hygiene",
        image: "https://images.unsplash.com/photo-1581887936036-3f4f7f0b6679?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGV0JTIwY2xlYW5pbmd8ZW58MHx8MHx8fDA%3D",
    },
];

export const flashDeals = [
    {
        id: 1,
        category: "Dog Essentials",
        title: "Royal Canin Puppy Food",
        originalPrice: 245,
        salePrice: 185,
        image: "https://images.unsplash.com/photo-1589924691995-400dc96ee382?w=300",
        unlockTime: { h: "02", m: "45", s: "12" }
    },
    {
        id: 2,
        category: "Cat Furniture",
        title: "Multi-Level Cat Tree",
        originalPrice: 450,
        salePrice: 299,
        image: "https://images.unsplash.com/photo-1545249390-6bdfa286032f?w=300",
        unlockTime: { h: "05", m: "20", s: "36" }
    },
    {
        id: 3,
        category: "Health Care",
        title: "Pro Grooming Kit",
        originalPrice: 199,
        salePrice: 110,
        image: "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=300",
        unlockTime: { h: "05", m: "20", s: "36" }
    },
    {
        id: 4,
        category: "Aquarium",
        title: "Smart LED Coral Tank",
        originalPrice: 899,
        salePrice: 649,
        image: "https://images.unsplash.com/photo-1522069169874-c58ec4b76be5?w=300",
        unlockTime: { h: "08", m: "15", s: "00" }
    }
];

export const menu: MenuItem[] = [
  
    {
        id: "card",
        label: "Credit / Debit Card",
        icon: CreditCard,
    },
    {
        id: "apple",
        label: "Apple Pay",
        image: ImagePath.ApplePay,
    },
];

export const FREE_PRODUCT = {
    id: "free-product",
    title: "Free Cat Treat 🎁",
    brand: "Josera",
    price: "AED 0.00",
    originalPrice: "AED 0.00",
    timer: "",
    image: "https://upload.wikimedia.org/wikipedia/commons/1/17/A_Dog_biscuit.jpg", // or real image
    subimage: [],
};

export const REWARD_PRODUCTS = [
    {
        id: 1,
        title: "Free Treat",
        brand: "Reward",
        price: "₹0",
        originalPrice: "₹0",
        timer: "",
        image: "https://images.unsplash.com/photo-1655210913151-87ce369ff7d8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y2F0JTIwZm9vZHxlbnwwfHwwfHx8MA%3D%3D",
        subimage: [],
        isReward: true,
    },
    {
        id: 2,
        title: "Free Toy",
        brand: "Reward",
        price: "₹0",
        originalPrice: "₹0",
        timer: "",
        image: "https://media.istockphoto.com/id/157641819/photo/cat-toys.webp?a=1&b=1&s=612x612&w=0&k=20&c=HgCwjCBWvSUja0sYwerBvdFZIYYvNofRVBl_TRVcdeM=",
        subimage: [],
        isReward: true,
    },
    {
        id: 3,
        title: "Free Food Pack",
        brand: "Reward",
        price: "₹0",
        originalPrice: "₹0",
        timer: "",
        image: "https://images.unsplash.com/photo-1696507398228-78f0368ddbc1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGNhdCUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        subimage: [],
        isReward: true,
    },
];

export const rewardTooltipData = {
    title: "How it works",
    points: [
        "You earn loyalty points based on cart value",
        "Every purchase adds points to your account",
        "You can redeem up to 0.1% of your total points",
    ],
};

export const couponList = [
    {
        code: "EXTRA50",
        title: "Save AED 50",
        description: "AED 50 off on minimum purchase of AED 400",
        expiry: "15 July 2026",
        maxSavings: 50,
    },
    {
        code: "WELCOME20",
        title: "10% OFF",
        description: "Get 10% off on first order",
        expiry: "30 Dec 2026",
        maxSavings: 100,
    },
    {
        code: "WELCOME90",
        title: "10% OFF",
        description: "Get 10% off on first order",
        expiry: "30 Dec 2026",
        maxSavings: 100,
    },
    {
        code: "WELCOME10",
        title: "10% OFF",
        description: "Get 10% off on first order",
        expiry: "30 Dec 2026",
        maxSavings: 100,
    },
];

export const rewardsData = [
    { threshold: 200, title: REWARD_PRODUCTS[0].title, image: REWARD_PRODUCTS[0].image },
    { threshold: 300, title: REWARD_PRODUCTS[1].title, image: REWARD_PRODUCTS[1].image },
    { threshold: 500, title: REWARD_PRODUCTS[2].title, image: REWARD_PRODUCTS[2].image },
];

export const MyAccount = [
    { id: 'profile', text: 'Profile' },
    {
        id: "orders",
        text: "My Orders",
    },
    { id: 'addresses', text: 'Address' },
    { id: 'Subscription', text: 'Order Subscription' },
        {id:'myBookings', text:"My Bookings"},
     { id: 'wallet', text: 'Wallet' },
    { id: 'rewards', text: 'Rewards' },
    {id:"referral", text:"My Referral"},
    { id: 'notifications', text: 'Notifications' },

    { id: 'signout', text: 'Signout' },
];

export const countryCodes: Option[] = [
    { id: "1", label: "+971", value: "AE", image: ImagePath.UAE },
    { id: "2", label: "+91", value: "IN", image: ImagePath.India },
    { id: "3", label: "+1", value: "US", image: ImagePath.USA },
    { id: "4", label: "+44", value: "GB", image: ImagePath.UK },
    { id: "5", label: "+61", value: "AU", image: ImagePath.Australia },
    { id: "6", label: "+1", value: "CA", image: ImagePath.Canada },
    { id: "7", label: "+966", value: "SA", image: ImagePath.SaudiArabia },
    { id: "8", label: "+974", value: "QA", image: ImagePath.Qatar },
    { id: "9", label: "+965", value: "KW", image: ImagePath.Kuwait },
    { id: "10", label: "+968", value: "OM", image: ImagePath.Oman },
    { id: "11", label: "+973", value: "BH", image: ImagePath.Bahrain },
    { id: "12", label: "+20", value: "EG", image: ImagePath.Egypt },
    { id: "13", label: "+92", value: "PK", image: ImagePath.Pakistan },
    { id: "14", label: "+880", value: "BD", image: ImagePath.Bangladesh },
    { id: "15", label: "+94", value: "LK", image: ImagePath.SriLanka },
    { id: "16", label: "+977", value: "NP", image: ImagePath.Nepal },
    { id: "17", label: "+975", value: "BT", image: ImagePath.Bhutan },
    { id: "18", label: "+60", value: "MY", image: ImagePath.Malaysia },
    { id: "19", label: "+65", value: "SG", image: ImagePath.Singapore },
    { id: "20", label: "+66", value: "TH", image: ImagePath.Thailand },
  ];

export const breedOptionsMap: Record<string, Option[]> = {
    dog: [
        { id: "1", label: "Golden Retriever", value: "Golden Retriever" },
        { id: "2", label: "Labrador Retriever", value: "Labrador Retriever" },
        { id: "3", label: "German Shepherd", value: "German Shepherd" },
        { id: "4", label: "Pug", value: "Pug" },
        { id: "5", label: "Beagle", value: "Beagle" },
        { id: "6", label: "Shih Tzu", value: "Shih Tzu" },
        { id: "7", label: "Rottweiler", value: "Rottweiler" },
        { id: "8", label: "Doberman", value: "Doberman" },
        { id: "9", label: "Siberian Husky", value: "Siberian Husky" },
        { id: "10", label: "Pomeranian", value: "Pomeranian" },
        { id: "11", label: "Dachshund", value: "Dachshund" },
        { id: "12", label: "Border Collie", value: "Border Collie" },
        { id: "13", label: "Great Dane", value: "Great Dane" },
        { id: "14", label: "Boxer", value: "Boxer" },
        { id: "15", label: "Chihuahua", value: "Chihuahua" },
        { id: "16", label: "Indian Spitz", value: "Indian Spitz" },
        { id: "17", label: "Rajapalayam", value: "Rajapalayam" },
        { id: "18", label: "Indie", value: "Indie" },
    ],

    cat: [
        { id: "101", label: "Persian", value: "Persian" },
        { id: "102", label: "Siamese", value: "Siamese" },
        { id: "103", label: "Maine Coon", value: "Maine Coon" },
        { id: "104", label: "Bengal", value: "Bengal" },
        { id: "105", label: "British Shorthair", value: "British Shorthair" },
        { id: "106", label: "Ragdoll", value: "Ragdoll" },
        { id: "107", label: "Sphynx", value: "Sphynx" },
        { id: "108", label: "Russian Blue", value: "Russian Blue" },
        { id: "109", label: "Scottish Fold", value: "Scottish Fold" },
        { id: "110", label: "Himalayan", value: "Himalayan" },
        { id: "111", label: "Domestic Shorthair", value: "Domestic Shorthair" },
    ],

    bird: [
        { id: "201", label: "Parrot", value: "Parrot" },
        { id: "202", label: "Budgie", value: "Budgie" },
        { id: "203", label: "Cockatiel", value: "Cockatiel" },
        { id: "204", label: "Lovebird", value: "Lovebird" },
        { id: "205", label: "Canary", value: "Canary" },
        { id: "206", label: "Macaw", value: "Macaw" },
        { id: "207", label: "Finch", value: "Finch" },
        { id: "208", label: "African Grey", value: "African Grey" },
        { id: "209", label: "Cockatoo", value: "Cockatoo" },
    ],

    "small pet": [
        { id: "301", label: "Hamster", value: "Hamster" },
        { id: "302", label: "Rabbit", value: "Rabbit" },
        { id: "303", label: "Guinea Pig", value: "Guinea Pig" },
        { id: "304", label: "Ferret", value: "Ferret" },
        { id: "305", label: "Chinchilla", value: "Chinchilla" },
        { id: "306", label: "Gerbil", value: "Gerbil" },
        { id: "307", label: "Mouse", value: "Mouse" },
        { id: "308", label: "Rat", value: "Rat" },
        { id: "309", label: "Holland Lop Rabbit", value: "Holland Lop Rabbit" },
        { id: "310", label: "Lionhead Rabbit", value: "Lionhead Rabbit" },
    ],

    reptile: [
        { id: "401", label: "Turtle", value: "Turtle" },
        { id: "402", label: "Tortoise", value: "Tortoise" },
        { id: "403", label: "Iguana", value: "Iguana" },
        { id: "404", label: "Gecko", value: "Gecko" },
        { id: "405", label: "Bearded Dragon", value: "Bearded Dragon" },
        { id: "406", label: "Chameleon", value: "Chameleon" },
        { id: "407", label: "Corn Snake", value: "Corn Snake" },
        { id: "408", label: "Ball Python", value: "Ball Python" },
    ],

    aquatic: [
        { id: "501", label: "Goldfish", value: "Goldfish" },
        { id: "502", label: "Betta Fish", value: "Betta Fish" },
        { id: "503", label: "Guppy", value: "Guppy" },
        { id: "504", label: "Angelfish", value: "Angelfish" },
        { id: "505", label: "Koi Fish", value: "Koi Fish" },
        { id: "506", label: "Oscar Fish", value: "Oscar Fish" },
        { id: "507", label: "Molly Fish", value: "Molly Fish" },
        { id: "508", label: "Tetra Fish", value: "Tetra Fish" },
        { id: "509", label: "Discus Fish", value: "Discus Fish" },
    ],

    other: [
        { id: "999", label: "Mixed Breed", value: "Mixed Breed" },
        { id: "1000", label: "Unknown", value: "Unknown" },
    ],
};

export const genderOptions: Option[] = [
    { id: '1', label: "Male", value: "Male" },
    { id: '2', label: "Female", value: "Female" },
];

export const petTypes = [
    {
        id: '1',
        label: "CAT",
        image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/25d45014-8cc3-4c98-b02c-5a0cf3a55ddd/dcopdcg-85a7601e-e7ca-4de8-96d6-28df58309247.png/v1/fill/w_900,h_703/domestic_cat_on_a_transparent_background_by_prussiaart_dcopdcg-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzAzIiwicGF0aCI6Ii9mLzI1ZDQ1MDE0LThjYzMtNGM5OC1iMDJjLTVhMGNmM2E1NWRkZC9kY29wZGNnLTg1YTc2MDFlLWU3Y2EtNGRlOC05NmQ2LTI4ZGY1ODMwOTI0Ny5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.fJA2_zPSu1i9xj2aH3mOsHrbnBI_JEDOQm2oTeMl498",
    },
    {
        id: '2',
        label: "DOG",
        image: "https://png.pngtree.com/png-clipart/20250118/original/pngtree-golden-retriever-dog-pictures-png-image_20183713.png",
    },
    {
        id: '3',
        label: "BIRD",
        image: "https://static.vecteezy.com/system/resources/previews/059/595/357/non_2x/sun-conure-parrot-isolated-exotic-pet-bird-profile-detailed-plumage-cut-out-transparent-png.png",
    },
    {
        id: '4',
        label: "SMALL PET",
        image: "https://png.pngtree.com/png-vector/20250620/ourmid/pngtree-hamster-isolated-on-a-transparent-background-png-image_16555349.png",
    },
    {
        id: '5',
        label: "REPTILE",
        image: "https://png.pngtree.com/png-vector/20240712/ourmid/pngtree-a-reptiles-png-image_13066752.png",
    },
    {
        id: '6',
        label: "AQUATIC",
        image: "https://png.pngtree.com/png-clipart/20240416/original/pngtree-fish-without-background-png-image_14843713.png",
    },



];

export const foodOptions = [
    { id: '1', label: "Chicken", value: "Chicken" },
    { id: '2', label: "Fish", value: "Fish" },
    { id: '3', label: "Veg", value: "Veg" },
    { id: '4', label: "Mixed", value: "Mixed" },
];

export const activityLevels = [
    { id: '1', label: "Low" },
    { id: '2', label: "Moderate" },
    { id: '3', label: "Highly Active" },
];

export const personalityOptions = [
    { id: "1", label: "Playful", value: "Playful", icon: Smile },
    { id: "2", label: "Cuddly", value: "Cuddly", icon: Heart },
    { id: "3", label: "Energetic", value: "Energetic", icon: Zap },
    { id: "4", label: "Smart", value: "Smart", icon: Brain },
    { id: "5", label: "Vocal", value: "Vocal", icon: Volume2 },
    { id: "6", label: "Protective", value: "Protective", icon: Shield },
    { id: "7", label: "Friendly", value: "Friendly", icon: Handshake },
    { id: "8", label: "Loyal", value: "Loyal", icon: ShieldCheck },
    { id: "9", label: "Calm", value: "Calm", icon: Moon },
    { id: "10", label: "Curious", value: "Curious", icon: Search },
    { id: "11", label: "Shy", value: "Shy", icon: EyeOff },
    { id: "12", label: "Independent", value: "Independent", icon: User },
    { id: "13", label: "Affectionate", value: "Affectionate", icon: HeartHandshake },
    { id: "14", label: "Lazy", value: "Lazy", icon: Bed },
    { id: "15", label: "Alert", value: "Alert", icon: Bell },
    { id: "16", label: "Fearless", value: "Fearless", icon: Flame },
    { id: "17", label: "Gentle", value: "Gentle", icon: Flower2 },
    { id: "18", label: "Aggressive", value: "Aggressive", icon: Swords },
    { id: "19", label: "Social", value: "Social", icon: Users },
    { id: "20", label: "Mischievous", value: "Mischievous", icon: Laugh },
    { id: "21", label: "Territorial", value: "Territorial", icon: MapPinned },
    { id: "22", label: "Obedient", value: "Obedient", icon: BadgeCheck },
    { id: "23", label: "Adventurous", value: "Adventurous", icon: Compass },
    { id: "24", label: "Clingy", value: "Clingy", icon: Link },
    { id: "25", label: "Quiet", value: "Quiet", icon: VolumeX },
    { id: "26", label: "Hyperactive", value: "Hyperactive", icon: Activity },
    { id: "27", label: "Stubborn", value: "Stubborn", icon: CircleSlash },
    { id: "28", label: "Cheerful", value: "Cheerful", icon: Sun },
    { id: "29", label: "Watchful", value: "Watchful", icon: Eye },
    { id: "30", label: "Trainable", value: "Trainable", icon: GraduationCap },
];

export const colorOptions: Option[] = [
    { id: "1", label: "Black", value: "Black" },
    { id: "2", label: "White", value: "White" },
    { id: "3", label: "Brown", value: "Brown" },
    { id: "4", label: "Golden", value: "Golden" },
    { id: "5", label: "Cream", value: "Cream" },
    { id: "6", label: "Gray", value: "Gray" },
    { id: "7", label: "Mixed", value: "Mixed" },
    { id: "8", label: "Spotted", value: "Spotted" },
    { id: "9", label: "Tan", value: "Tan" },
    { id: "10", label: "Chocolate", value: "Chocolate" },
    { id: "11", label: "Red", value: "Red" },
    { id: "12", label: "Orange", value: "Orange" },
    { id: "13", label: "Yellow", value: "Yellow" },
    { id: "14", label: "Blue", value: "Blue" },
    { id: "15", label: "Green", value: "Green" },
    { id: "16", label: "Silver", value: "Silver" },
    { id: "17", label: "Beige", value: "Beige" },
    { id: "18", label: "Fawn", value: "Fawn" },
    { id: "19", label: "Brindle", value: "Brindle" },
    { id: "20", label: "Merle", value: "Merle" },
    { id: "21", label: "Tricolor", value: "Tricolor" },
    { id: "22", label: "Bicolor", value: "Bicolor" },
    { id: "23", label: "Calico", value: "Calico" },
    { id: "24", label: "Tabby", value: "Tabby" },
    { id: "25", label: "Tortoiseshell", value: "Tortoiseshell" },
    { id: "26", label: "Striped", value: "Striped" },
    { id: "27", label: "Speckled", value: "Speckled" },
    { id: "28", label: "Piebald", value: "Piebald" },
    { id: "29", label: "Albino", value: "Albino" },
    { id: "30", label: "Multicolor", value: "Multicolor" },
    { id: "31", label: "Pink", value: "Pink" },
    { id: "32", label: "Purple", value: "Purple" },
    { id: "33", label: "Copper", value: "Copper" },
    { id: "34", label: "Rust", value: "Rust" },
    { id: "35", label: "Chestnut", value: "Chestnut" },
    { id: "36", label: "Cinnamon", value: "Cinnamon" },
    { id: "37", label: "Peach", value: "Peach" },
    { id: "38", label: "Sable", value: "Sable" },
    { id: "39", label: "Lilac", value: "Lilac" },
    { id: "40", label: "Buff", value: "Buff" },
    { id: "41", label: "Harlequin", value: "Harlequin" },
    { id: "42", label: "Mottled", value: "Mottled" },
    { id: "43", label: "Smoke", value: "Smoke" },
    { id: "44", label: "Marbled", value: "Marbled" },
    { id: "45", label: "Other", value: "Other" },
];

export const dietaryOptions = [
    { id: "1", label: "Dry Food", value: "Dry Food" },
    { id: "2", label: "Wet Food", value: "Wet Food" },
    { id: "3", label: "Raw Diet", value: "Raw Diet" },
    { id: "4", label: "Grain-Free", value: "Grain-Free" },
    { id: "5", label: "Homemade Food", value: "Homemade Food" },
    { id: "6", label: "High Protein Diet", value: "High Protein Diet" },
    { id: "7", label: "Prescription Diet", value: "Prescription Diet" },
    { id: "8", label: "Vegetarian Diet", value: "Vegetarian Diet" },
    { id: "9", label: "Organic Food", value: "Organic Food" },
    { id: "10", label: "Freeze-Dried Food", value: "Freeze-Dried Food" },
    { id: "11", label: "Fresh Food", value: "Fresh Food" },
    { id: "12", label: "Mixed Diet", value: "Mixed Diet" },
];

export const dietfrequecy = [
    { id: '1', label: "2 Time" },
    { id: '2', label: "3 Time" },
    { id: '3', label: "4+ Times" },
];

export const protionSize = [
    { id: '1', label: "Small" },
    { id: '2', label: "Medium" },
    { id: '3', label: "Large" },
];

export const favouriteTreatOptions = [
    { id: "1", label: "Jerky Treats", value: "Jerky Treats" },
    { id: "2", label: "Training Treats", value: "Training Treats" },
    { id: "3", label: "Dental Chews", value: "Dental Chews" },
    { id: "4", label: "Chew Sticks", value: "Chew Sticks" },
    { id: "5", label: "Soft Chews", value: "Soft Chews" },
    { id: "6", label: "Freeze-Dried Treats", value: "Freeze-Dried Treats" },
    { id: "7", label: "Chicken Treats", value: "Chicken Treats" },
    { id: "8", label: "Fish Treats", value: "Fish Treats" },
    { id: "9", label: "Duck Treats", value: "Duck Treats" },
    { id: "10", label: "Peanut Butter Treats", value: "Peanut Butter Treats" },
    { id: "11", label: "Cheese Bites", value: "Cheese Bites" },
    { id: "12", label: "Bone Treats", value: "Bone Treats" },
    { id: "13", label: "Rawhide Chews", value: "Rawhide Chews" },
    { id: "14", label: "Crunchy Treats", value: "Crunchy Treats" },
    { id: "15", label: "Catnip Treats", value: "Catnip Treats" },
    { id: "16", label: "Creamy Lick Treats", value: "Creamy Lick Treats" },
    { id: "17", label: "Rabbit Chews", value: "Rabbit Chews" },
    { id: "18", label: "Seed Treats", value: "Seed Treats" },
    { id: "19", label: "Fruit Bites", value: "Fruit Bites" },
    { id: "20", label: "Veggie Snacks", value: "Veggie Snacks" },
];

export const suggestedConditions = [
    { id: "2", label: "Allergies" },
    { id: "3", label: "Joint Care" },
    { id: "4", label: "Skin Issues" },
    { id: "5", label: "Obesity / Weight Management" },
    { id: "6", label: "Dental Care" },
    { id: "7", label: "Digestive Issues" },
    { id: "8", label: "Sensitive Stomach" },
    { id: "9", label: "Heart Condition" },
    { id: "10", label: "Kidney Issues" },
    { id: "11", label: "Liver Problems" },
    { id: "12", label: "Diabetes" },
    { id: "13", label: "Arthritis" },
    { id: "14", label: "Hip Dysplasia" },
    { id: "15", label: "Eye Problems" },
    { id: "16", label: "Ear Infection" },
    { id: "17", label: "Respiratory Issues" },
    { id: "18", label: "Anxiety / Stress" },
    { id: "19", label: "Separation Anxiety" },
    { id: "20", label: "Flea & Tick Care" },
    { id: "21", label: "Tick Sensitivity" },
    { id: "22", label: "Wound Recovery" },
    { id: "23", label: "Post Surgery Care" },
    { id: "24", label: "Urinary Issues" },
    { id: "25", label: "Bladder Problems" },
    { id: "26", label: "Constipation" },
    { id: "27", label: "Vomiting Issues" },
    { id: "28", label: "Low Appetite" },
    { id: "29", label: "Hyperactivity" },
    { id: "30", label: "Aggressive Behavior" },
    { id: "31", label: "Hair Loss" },
    { id: "32", label: "Excessive Shedding" },
    { id: "33", label: "Nail Care" },
    { id: "34", label: "Beak Care" },
    { id: "35", label: "Feather Loss" },
    { id: "36", label: "Shell Care" },
    { id: "37", label: "Swimming Balance Issues" },
    { id: "38", label: "Fin Damage" },
    { id: "39", label: "Parasite Treatment" },
    { id: "40", label: "Vaccination Follow-up" },
];

export const groomingfrequecyOptions = [
    { id: '1', label: "Weekly" },
    { id: '2', label: "Monthly" },
    { id: '3', label: "Rare" },
];

export const sheddingfrequecyOptions = [
    { id: '1', label: "Low" },
    { id: '2', label: "Medium" },
    { id: '3', label: "High" },
];

export const groomingImage: SectionData[] = [
    {
        id: 1,
        src: "https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8Y2F0JTIwYW5kJTIwZG9nfGVufDB8fDB8fHww",
        type: "image",
    },
];

export const taxiImage: SectionData[] = [
    {
        id: 1,
        src: "https://images.unsplash.com/photo-1450096315186-13dc369ab43e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGV0JTIwdGF4aXxlbnwwfHwwfHx8MA%3D%3D",
        type: "image",
    },
];

export const trainingImage: SectionData[] = [
    {
        id: 1,
        src: "https://images.unsplash.com/photo-1660838528615-727eb57216e8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fHBldCUyMHRyYWluaW5nfGVufDB8fDB8fHww",
        type: "image",
    },
]

export const petOptions = [
    {
        id: "dog",
        label: "Dog",
        value: "dog",
        image: "https://images.unsplash.com/photo-1503256207526-0d5d80fa2f47?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZG9nfGVufDB8fDB8fHww",
    },
    {
        id: "cat",
        label: "Cat",
        value: "cat",
        image: "https://plus.unsplash.com/premium_photo-1673967831980-1d377baaded2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y2F0c3xlbnwwfHwwfHx8MA%3D%3D",

    },
    {
        id: "puppy",
        label: "Puppy",
        value: "puppy",
        image: "https://png.pngtree.com/png-clipart/20250118/original/pngtree-golden-retriever-dog-pictures-png-image_20183713.png",
    },
];

export const petTrainingOptions = [
    {
        id: "dog",
        label: "Dog",
        value: "dog",
        image: "https://images.unsplash.com/photo-1503256207526-0d5d80fa2f47?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZG9nfGVufDB8fDB8fHww",
    }
];

export const groomingData = {
    dog: {
        color: "#d90429",

        services: [
            {
                id: "hair",
                label: "Hair Cut / Trimming",
                value: "Hair Cut / Trimming",

                prices: [
                    {
                        size: "Small",
                        price: 110,
                    },
                    {
                        size: "Medium",
                        price: 130,
                    },
                    {
                        size: "Large",
                        price: 140,
                    },
                ],

                time: [
                    {
                        size: "Small",
                        time: "1 Hour",
                    },
                    {
                        size: "Medium",
                        time: "2 Hour",
                    },
                    {
                        size: "Large",
                        time: "3 Hour",
                    },
                ],
            },

            {
                id: "wash",
                label: "Groom Wash & Dry (WD)",
                value: "Groom Wash & Dry (WD)",

                prices: [
                    {
                        size: "Small",
                        price: 100,
                    },
                    {
                        size: "Medium",
                        price: 120,
                    },
                    {
                        size: "Large",
                        price: 130,
                    },
                ],

                time: [
                    {
                        size: "Small",
                        time: "1 Hour",
                    },
                    {
                        size: "Medium",
                        time: "2 Hour",
                    },
                    {
                        size: "Large",
                        time: "3 Hour",
                    },
                ],
            },

            {
                id: "wdc",
                label:
                    "(WDC) (Wash & Dry, Nails Clipping And Ear Cleaning, Paw Pad Trimming, Perfume, Hygiene Trimming)",

                value:
                    "(WDC) (Wash & Dry, Nails Clipping And Ear Cleaning, Paw Pad Trimming, Perfume, Hygiene Trimming)",

                prices: [
                    {
                        size: "Small",
                        price: 160,
                    },
                    {
                        size: "Medium",
                        price: 180,
                    },
                    {
                        size: "Large",
                        price: 200,
                    },
                ],

                time: [
                    {
                        size: "Small",
                        time: "1 Hour",
                    },
                    {
                        size: "Medium",
                        time: "2 Hour",
                    },
                    {
                        size: "Large",
                        time: "3 Hour",
                    },
                    {
                        size: "Giant",
                        time: "4 Hour",
                    },
                ],
            },

            {
                id: "wdcne",
                label:
                    "(WDCNE) (Wash & Dry, Hair Cut, Nails Clipping, Ear Cleaning, Teeth Brushing, Paw Pad Trimming, Anal Gland Cleaning, Perfume, Paw Moisturiser And Hygiene Trimming)",

                value:
                    "(WDCNE) (Wash & Dry, Hair Cut, Nails Clipping, Ear Cleaning, Teeth Brushing, Paw Pad Trimming, Anal Gland Cleaning, Perfume, Paw Moisturiser And Hygiene Trimming)",

                prices: [
                    {
                        size: "Small",
                        price: 200,
                    },
                    {
                        size: "Medium",
                        price: 250,
                    },
                    {
                        size: "Large",
                        price: 280,
                    },
                ],

                time: [
                    {
                        size: "Small",
                        time: "1 Hour",
                    },
                    {
                        size: "Medium",
                        time: "2 Hour",
                    },
                    {
                        size: "Large",
                        time: "3 Hour",
                    },
                ],
            },
        ],
    },

    cat: {
        color: "#b23be0",

        services: [
            {
                id: "wash",
                label: "GROOM WASH & DRY (WD)",
                value: "GROOM WASH & DRY (WD)",

                prices: [
                    {
                        size: "Cat",
                        price: 220,
                    },
                ],

                time: [
                    {
                        size: "Cat",
                        time: "2 Hour",
                    },
                ],
            },

            {
                id: "wdc",
                label:
                    "BASIC GROOM (Wash & Dry, Nails Clipping and Ear Cleaning, Paw Pad Trimming, Perfume, Hygiene Trimming)(WDC)",

                value:
                    "BASIC GROOM (Wash & Dry, Nails Clipping and Ear Cleaning, Paw Pad Trimming, Perfume, Hygiene Trimming)(WDC)",

                prices: [
                    {
                        size: "Cat",
                        price: 180,
                    },
                ],

                time: [
                    {
                        size: "Cat",
                        time: "2 Hour",
                    },
                ],
            },

            {
                id: "wdcne",
                label:
                    "FULL GROOM (Wash & Dry, Hair Cut, Nails Clipping, Ear Cleaning, Teeth Brushing, Paw Pad Trimming, Perfume, Hygiene Trimming)(WDCNE)",

                value:
                    "FULL GROOM (Wash & Dry, Hair Cut, Nails Clipping, Ear Cleaning, Paw Pad Trimming, Perfume, Hygiene Trimming)(WDCNE)",

                prices: [
                    {
                        size: "Cat",
                        price: 220,
                    },
                ],

                time: [
                    {
                        size: "Cat",
                        time: "2 Hour",
                    },
                ],
            },
        ],
    },
};

export const calendlyLinks: any = {
    "1 hour":
        "https://calendly.com/petland005/1hour",

    "2 hours":
        "https://calendly.com/petland005/2hour",

    "3 hours":
        "https://calendly.com/petland005/3hour",

    "4 hours":
        "https://calendly.com/petland005/4hour",
};

export const tableColumns: Column[] = [
    {
        key: "size",
        title: "SIZE",
    },
    {
        key: "price",
        title: "PRICE",
    },
    {
        key: "time",
        title: "TIME",
    },
];

export const columns = [
    { header: "SKU", accessor: "sku" },
    { header: "Product", accessor: "productinfo" },
    { header: "Quantity", accessor: "quantity" },
    { header: "Status", accessor: "status" },
    { header: "Actions", accessor: "actions" }, // <--- Add this column
  
];

export const data = [
    {
        id: '1',
        name: "Dog Food Premium",
        sku: "DOG-FOOD-001",
        remainingStock: 45,
    },
    {
        id: '2',
        name: "Cat Scratcher",
        sku: "CAT-SCR-002",
        remainingStock: 20,
    },
    {
        id: '3',
        name: "Bird Cage Deluxe",
        sku: "BIRD-CAGE-003",
        remainingStock: 12,
    },
    {
        id: '4',
        name: "Dog Shampoo",
        sku: "DOG-SHAM-004",
        remainingStock: 60,
    },
    {
        id: '5',
        name: "Fish Tank Filter",
        sku: "FISH-FILT-005",
        remainingStock: 15,
    },
    {
        id: '6',
        name: "Pet Bed Large",
        sku: "PET-BED-006",
        remainingStock: 8,
    },
    {
        id: '7',
        name: "Rabbit Hay Pack",
        sku: "RAB-HAY-007",
        remainingStock: 35,
    },
    {
        id: '8',
        name: "Dog Leash",
        sku: "DOG-LEASH-008",
        remainingStock: 70,
    },
    {
        id: '9',
        name: "Pet Vitamins",
        sku: "PET-VIT-009",
        remainingStock: 28,
    },
    {
        id: '10',
        name: "Automatic Feeder",
        sku: "AUTO-FEED-010",
        remainingStock: 5,
    },
];

export const categoryOptions: Option[] = [
    { id: "1", label: "Dog", value: "dog" },
    { id: "2", label: "Cat", value: "cat" },
    { id: "3", label: "Puppy", value: "puppy" },
    { id: "3", label: "Kitten", value: "kitten" },
];

export const subCategoryOptions: Option[] = [
    { id: "1", label: "Dry Food", value: "dry-food" },
    { id: "2", label: "Toys", value: "toys" },
    { id: "3", label: "Beds", value: "beds" },
];

export const claimOptions: Option[] = [
    { id: "1", label: "True", value: "true" },
    { id: "2", label: "False", value: "false" },
];

export const weightOptions: Option[] = [
    { id: "1", label: "100gm", value: "100gm" },
    { id: "2", label: "200gm", value: "200gm" },
    { id: "3", label: "500gm", value: "500gm" },
    { id: "4", label: "1kg", value: "1kg" },
    { id: "5", label: "2kg", value: "2kg" },
    { id: "6", label: "5kg", value: "5kg" },
    { id: "7", label: "Custom", value: "custom" },
];

export const sizeOptions: Option[] = [
    { id: "1", label: "S", value: "s" },
    { id: "2", label: "M", value: "m" },
    { id: "3", label: "L", value: "l" },
    { id: "4", label: "XL", value: "xl" },
    { id: "5", label: "Custom", value: "custom" },
];

export const flavourOptions: Option[] = [
    { id: "1", label: "Chicken", value: "chicken" },
    { id: "2", label: "Beef", value: "beef" },
    { id: "3", label: "Salmon", value: "salmon" },
    { id: "4", label: "Lamb", value: "lamb" },
    { id: "5", label: "Turkey", value: "turkey" },
    { id: "6", label: "Tuna", value: "tuna" },
    { id: "7", label: "Duck", value: "duck" },
    { id: "8", label: "Mixed Meat", value: "mixed-meat" },
    { id: "9", label: "Custom", value: "custom" },
];

export const statsData = [
    {
        title: "Total Orders",
        value: "24,560",
        growth: "+18%",
        icon: ShoppingBag,
        iconBg: "bg-blue-100",
        iconColor: "text-blue-600",
    },
    {
        title: "Total Revenue",
        value: "AED 32,890",
        growth: "+22%",
        icon: ReceiptText,
        iconBg: "bg-green-100",
        iconColor: "text-green-600",
    },
    {
        title: "Total Profit",
        value: "AED 8,240",
        growth: "+10%",
        icon: WalletCards,
        iconBg: "bg-emerald-100",
        iconColor: "text-emerald-600",
    },
    {
        title: "Total Customers",
        value: "8,240",
        growth: "+12%",
        icon: Users,
        iconBg: "bg-violet-100",
        iconColor: "text-violet-600",
    },
    {
        title: "Grooming Bookings",
        value: "1,420",
        growth: "+30%",
        icon: Scissors,
        iconBg: "bg-orange-100",
        iconColor: "text-orange-600",
    },
    {
        title: "New Pets Onboard",
        value: "560",
        growth: "+20%",
        icon: PawPrint,
        iconBg: "bg-pink-100",
        iconColor: "text-pink-600",
    },
];

export const topCategories = [
    {
        name: "Dog Food",
        percent: "48%",
        width: "48%",
    },
    {
        name: "Cat Food",
        percent: "32%",
        width: "32%",
    },
    {
        name: "Kitten Food",
        percent: "15%",
        width: "15%"
    },
    {
        name: "Puppy Food",
        percent: "15%",
        width: "15%",
    },
    {
        name: "Dog Toys",
        percent: "48%",
        width: "48%",
    },
    {
        name: "Cat Toys",
        percent: "32%",
        width: "32%",
    },
];

export const topProducts = [
    {
        name: "Royal Canin Dog Food",
        amount: "AED 240",
        status: "Delivered",
        time: "2 mins ago",
    },
    {
        name: "Leather Dog Collar",
        amount: "AED 180",
        status: "Shipped",
        time: "10 mins ago",
    },
    {
        name: "Pet Shampoo",
        amount: "AED 140",
        status: "Pending",
        time: "25 mins ago",
    },
    {
        name: "Cat Toy Bundle",
        amount: "AED 120",
        status: "Processing",
        time: "40 mins ago",
    },
];

export const Donutdata = [
    {
        label: "Pet Food",
        value: 35,
        color: "#047857",
    },
    {
        label: "Accessories",
        value: 20,
        color: "#34D399",
    },
    {
        label: "Grooming",
        value: 18,
        color: "#FBBF24",
    },
    {
        label: "Health & Hygiene",
        value: 15,
        color: "#6366F1",
    },
    {
        label: "Toys",
        value: 12,
        color: "#EC4899",
    },
]

export const PaymentOptions = [
    {
        label: "Card",
        value: 40,
        color: "#0F766E",
    },
    {
        label: "Wallet",
        value: 20,
        color: "#34D399",
    },
    {
        label: "Tabby",
        value: 15,
        color: "#6366F1",
    },
    {
        label: "Tamara",
        value: 100,
        color: "#EC4899",
    },
    {
        label: "Autoship",
        value: 85,
        color: "#FBBF24",
    },
]

export const CustomerLoyalty = [
    {
        label: "New Customer",
        value: 1245,
        percentage: 100,
        color: "#D1D5DB",
        textColor: "#111827",
    },
    {
        label: "Repeat Customer",
        value: 845,
        percentage: 85,
        color: "#60A5FA",
    },
    {
        label: "Frequent Customer",
        value: 620,
        percentage: 70,
        color: "#34D399",
    },
    {
        label: "Loyal Customer",
        value: 310,
        percentage: 55,
        color: "#A78BFA",
    },
    {
        label: "VIP Customer",
        value: 120,
        percentage: 40,
        color: "#F59E0B",
    },
]

export const TopCustomers = [
    {
        name: "Ravi Sharma",
        amount: "AED 12,540",
        image: "https://img.magnific.com/premium-photo/engaging-lifestyle-photograph-capturing-modern-young-indian-man_948023-4921.jpg?semt=ais_hybrid&w=740&q=80",
        badge: "VIP Customer",
    },
    {
        name: "Priya Mehta",
        amount: "AED 9,870",
        image: "https://thumbs.dreamstime.com/b/webcam-view-happy-indian-woman-laughing-looking-camera-close-up-webcam-profile-picture-view-happy-indian-woman-laughing-330122332.jpg",
        badge: "Loyal Customer",
    },
    {
        name: "Ankit Verma",
        amount: "AED 7,650",
        image: "https://img.magnific.com/free-photo/cheerful-indian-businessman-smiling-closeup-portrait-jobs-career-campaign_53876-129416.jpg?semt=ais_hybrid&w=740&q=80",
        badge: "Frequent Customer",
    },
    {
        name: "Sneha Kapoor",
        amount: "AED 6,320",
        image: "https://img.magnific.com/free-photo/indian-woman-posing-cute-stylish-outfit-camera-smiling_482257-122351.jpg?semt=ais_hybrid&w=740&q=80",
        badge: "Repeat Customer",
    },
]

export const marketingInsightsData = [
    {
        title: "Products On Discount",
        value: "245",
        growth: "+12%",
        icon: BadgePercent,
        iconBg: "bg-amber-100",
        iconColor: "text-amber-600",
    },
    {
        title: "Banner Clicks",
        value: "18,420",
        growth: "+28%",
        icon: MousePointerClick,
        iconBg: "bg-sky-100",
        iconColor: "text-sky-600",
    },
    {
        title: "Most Used Coupon",
        value: "SAVE20",
        growth: "+16%",
        icon: TicketPercent,
        iconBg: "bg-violet-100",
        iconColor: "text-violet-600",
    },
    {
        title: "Refer & Earn Users",
        value: "1,245",
        growth: "+21%",
        icon: Gift,
        iconBg: "bg-pink-100",
        iconColor: "text-pink-600",
    },
];

export const customerInsightsData = [
    {
        title: "Abandoned Cart Orders",
        value: "324",
        growth: "+14%",
        icon: ShoppingCart,
        iconBg: "bg-orange-100",
        iconColor: "text-orange-600",
    },
    {
        title: "Tips & Donations",
        value: "1,120",
        growth: "+9%",
        icon: HeartHandshake,
        iconBg: "bg-rose-100",
        iconColor: "text-rose-600",
    },
    {
        title: "Return Requests",
        value: "86",
        growth: "-4%",
        icon: RotateCcw,
        iconBg: "bg-red-100",
        iconColor: "text-red-600",
    },
    {
        title: "Active Autoship Users",
        value: "542",
        growth: "+18%",
        icon: RefreshCw,
        iconBg: "bg-cyan-100",
        iconColor: "text-cyan-600",
    },
];

export const productInsightsData = [
    {
        title: "Most Viewed Products",
        value: "12,480",
        growth: "+24%",
        icon: Eye,
        iconBg: "bg-blue-100",
        iconColor: "text-blue-600",
    },
    {
        title: "Most Searched Products",
        value: "8,920",
        growth: "+19%",
        icon: Search,
        iconBg: "bg-violet-100",
        iconColor: "text-violet-600",
    },
    {
        title: "Free Gift Claims",
        value: "1,245",
        growth: "+15%",
        icon: Gift,
        iconBg: "bg-pink-100",
        iconColor: "text-pink-600",
    },
    {
        title: "Claimed Gift Product",
        value: "Dog Treat Box",
        growth: "+11%",
        icon: PackageCheck,
        iconBg: "bg-emerald-100",
        iconColor: "text-emerald-600",
    },
];

export const gamificationData = [
    {
        title: "Gamification Users",
        value: "3,240",
        growth: "+26%",
        icon: Gamepad2,
        iconBg: "bg-indigo-100",
        iconColor: "text-indigo-600",
    },
    {
        title: "Repeated Game Users",
        value: "1,420",
        growth: "+18%",
        icon: Trophy,
        iconBg: "bg-amber-100",
        iconColor: "text-amber-600",
    },
    {
        title: "Most Played Game",
        value: "Spin & Win",
        growth: "+32%",
        icon: Joystick,
        iconBg: "bg-fuchsia-100",
        iconColor: "text-fuchsia-600",
    },
    {
        title: "Pet Profiles Count",
        value: "5,860",
        growth: "+21%",
        icon: PawPrint,
        iconBg: "bg-pink-100",
        iconColor: "text-pink-600",
    },
];

export const calendarOptions: Option[] = [
    { id: "1", label: "Today", value: "today" },
    { id: "2", label: "This Week", value: "thisWeek" },
    { id: "3", label: "This Month", value: "thisMonth" },
];

export const screenOptions = [
    {
        id: "1",
        label: "Products",
        value: "products",
    },
    {
        id: "2",
        label: "Pets",
        value: "pets",
    },
    {
        id: "3",
        label: "Services",
        value: "services",
    },
];

export const deviceOptions: Option[] = [
    { id: '1', label: "Web", value: "1" },
    { id: '2', label: "Android", value: "2" },
    { id: '3', label: "IOS", value: "3" },
    { id: '4', label: "App", value: "4" },
];

export const ReorderUiDemo = [
    {
        "id": 1,
        "screenName": "Products",
        "sectionName": "MainCarousel",
        "displayOrder": 1,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 2,
        "screenName": "Products",
        "sectionName": "CategorySlider",
        "displayOrder": 2,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 4,
        "screenName": "Products",
        "sectionName": "ProductCarouselSection-WithOffer-One",
        "displayOrder": 3,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 5,
        "screenName": "Products",
        "sectionName": "PeekCarousel",
        "displayOrder": 4,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 6,
        "screenName": "Products",
        "sectionName": "BrandsSlider",
        "displayOrder": 5,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 7,
        "screenName": "Products",
        "sectionName": "PeekCarousel",
        "displayOrder": 6,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 8,
        "screenName": "Products",
        "sectionName": "ProductCarouselSection-WithOffer-Two",
        "displayOrder": 7,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 9,
        "screenName": "Products",
        "sectionName": "TypesOfPetSlider",
        "displayOrder": 8,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 10,
        "screenName": "Products",
        "sectionName": "SqaureBanner",
        "displayOrder": 9,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 11,
        "screenName": "Products",
        "sectionName": "ProductCarouselSection-WithoutOffer",
        "displayOrder": 10,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 12,
        "screenName": "Products",
        "sectionName": "AdBannerImageRight",
        "displayOrder": 11,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    },
    {
        "id": 13,
        "screenName": "Products",
        "sectionName": "VideoBanners-One",
        "displayOrder": 12,
        "isVisible": true,
        "platform": 1,
        "configJson": null
    }
]

export const userTypeOptions: Option[] = [
    { id: "1", label: "New Customer", value: "newCust" },
    { id: "2", label: "Repeat Customer", value: "repeatCust" },
    { id: "3", label: "Frequent Customer", value: "freqCust" },
    { id: "4", label: "Loyal Customer", value: "loyalCust" },
    { id: "5", label: "VIP Customer", value: "vipCust" },
    { id: "5", label: "All Users", value: "all" },
];

export const filterOptions: Option[] = [
    {
        id: "1",
        label: "Price: Low to High",
        value: "priceLow",
    },
    {
        id: "2",
        label: "Price: High to Low",
        value: "priceHigh",
    },
    {
        id: "3",
        label: "Quantity: Low Stock",
        value: "qtyLow",
    },
    {
        id: "4",
        label: "Quantity: High Stock",
        value: "qtyHigh",
    },
];

export const fullProductStructure = [
    {
        id: '1',
        sku: "Dog-Food-001",
        productname: "Josera Nature Cat Dry Food Good for Cat",
        brand: "Josera",
        saleprice: "AED 51.10",
        price: "AED 70.00",
        timer: "02:30:15",
        productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-2705-josera-nature-cat-dry-food-2kg/17737339772093070531-230x220.jpg",
        subimage: [
            { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547408441010803229.jpg" },
            { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/1754740845541444861.jpg" },
            { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547422901936586973.jpg" }
        ],
        quantity: 1,
        status: true,
        cartPrice: "AED 200",
        userType: "New Customer"
    },
    {
        id: '2',
        sku: "Dog-Food-002",
        productname: "Josera Kitten Cat Dry Food Good for Kitten",
        brand: "Josera",
        saleprice: "AED 47.60",
        price: "AED 70.00",
        timer: "03:20:15",
        productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-1306-josera-kitten-cat-dry-food-2kg/1773734070905639323-230x220.jpg",
        subimage: [
            { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71R+n5jvYZL._AC_SL1200_.jpg" },
            { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61Z0MiydjBL._AC_SL1200_.jpg" },
            { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61aYcqFs9kL._AC_SL1200_.jpg" }
        ],
        quantity: 1,
        status: true,
        cartPrice: "AED 200",
        userType: "Loyal Customer"
    },
]

export const freecolumns = [
    { header: "SKU", accessor: "sku" },
    { header: "Product", accessor: "productinfo" },
    { header: "Cart Price", accessor: "cartPrice" },
    { header: "User Type", accessor: "userType" },
    { header: "Quantity", accessor: "quantity" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" },
];


export const packageData = [
    {
        title: "Monthly Care Package",
        subtitle: "1 Grooming every month (valid 3 months)",
        price: "AED 620",
        extra: "Small dog",
        description: "Perfect routine grooming package for maintaining your pet's hygiene and coat health.",
        features: [
            "Monthly grooming session",
            "Bath & dry",
            "Nail trim",
            "Coat maintenance",
        ],
        icon: Scissors,
        bg: "from-green-50 to-green-100",
        iconBg: "bg-green-600",
        image:
            "https://images.unsplash.com/photo-1517849845537-4d257902454a?w=500",
    },

    {
        title: "Puppy Care Package",
        subtitle: "Best for puppies under 6 months",
        price: "AED 320",
        extra: "3 Sessions",
        description:
            "Gentle grooming experience specially designed for young puppies.",
        features: [
            "Gentle bath & dry",
            "Nail trim",
            "Face tidy",
            "Paw tidy",
        ],
        icon: Heart,
        bg: "from-orange-50 to-yellow-100",
        iconBg: "bg-orange-500",
        image:
            "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=500",
    },

    {
        title: "Cat Comfort Package",
        subtitle: "Premium care for long coat breeds",
        price: "AED 270 - 320",
        extra: "Cat Care",
        description:
            "Designed for shedding control and coat maintenance.",
        features: [
            "Cat bath & blow dry",
            "De-shedding",
            "Nail trim",
            "Ear cleaning",
        ],
        icon: Sparkles,
        bg: "from-purple-50 to-pink-100",
        iconBg: "bg-purple-600",
        image:
            "https://images.unsplash.com/photo-1519052537078-e6302a4968d4?w=500",
    },
];


export const bannerData = [
    {
        tag: "Relocation",
        title: "Moving to Abu Dhabi or Sharjah?",
        description:
            "Municipality approved pet transport with climate control and vet attendance.",
        buttonText: "Request DXB Quote",
        image:
            "https://images.unsplash.com/photo-1522850949506-58555ed15981?w=400",
    },

    {
        tag: "Vet Clinic",
        title: "Premium Veterinary Care",
        description:
            "Expert veterinarians providing health checkups, vaccinations and wellness care.",
        buttonText: "Book Appointment",
        image:
            "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=500",
        bgColor: "bg-[#E8F5E9]",
        tagClass: "bg-mainBrandColor text-white",
        buttonClass: "bg-mainBrandColor",
        reverse: true,
    },
];

export const packagesData = [
    {
        packageId: "1",
        packageTitle: "PACKAGE 1:",
        packageSubtitle: "Fresh & Clean",
        description: "Best for regular maintenance, first-time clients",
        time: "60",
        validFor: ["dog", "cat"],
        includes: [
            "Bath with premium shampoo",
            "Blow dry & brushing",
            "Nail trimming",
            "Ear cleaning",
            "Light face & paw tidy",
            "Sanitary trim",
        ],
        isSpecialPackage: false,
        pricing: [
            { size: 'small', label: "Small dog", price: "AED 200", salePrice: "AED 160" },
            { size: 'medium', label: "Medium dog", price: "AED 230", salePrice: "AED 190" },
            { size: 'large', label: "Large dog", price: "AED 260", salePrice: "AED 220" },
            { label: "Cat", price: "AED 230", salePrice: "AED 190" },
        ],
    },
    {
        packageId: "2",
        packageTitle: "PACKAGE 2:",
        packageSubtitle: "Full Groom (Most Popular)",
        description: "Best for: regular grooming, styled look. Includes everything in Fresh & Clean +",
        time: "90",
        validFor: ["dog", "cat"],
        isSpecialPackage: false,
        includes: [
            "Full haircut / styling",
            "Sanitary trim",
            "Paw pad clean",
            "Perfume finish",
            "Nail clipping",
            "Teeth brushing",
        ],
        pricing: [
            { size: 'small', label: "Small dog", price: "AED 280", salePrice: "AED 240" },
            { size: 'medium', label: "Medium dog", price: "AED 340", salePrice: "AED 300" },
            { size: 'large', label: "Large dog", price: "AED 410", salePrice: "AED 370" },
            { label: "Cat", price: "AED 340", salePrice: "AED 300" },
        ],
    },
    {
        packageId: "3",
        packageTitle: "PACKAGE 3:",
        packageSubtitle: "Petland Spa Experience",
        time: "90",
        isSpecialPackage: false,
        description: "Best for a premium look, long-coat breeds, shedding issues. Includes everything in Full Groom +",
        validFor: ["dog", "cat"],
        includes: [
            "De-shedding or deep conditioning mask",
            "Teeth brushing",
            "Paw balm application",
            "Premium fragrance",
            "Nail clipping",
            "Complimentary treat",
        ],
        pricing: [
            { size: 'small', label: "Small dog", price: 'AED 360', salePrice: "AED 320" },
            { size: 'medium', label: "Medium dog", price: 'AED 440', salePrice: "AED 400" },
            { size: 'large', label: "Large dog", price: 'AED 540', salePrice: "AED 500" },
            { label: "Cat", price: "AED 370" },
        ],
    },
    {
        packageId: "4",
        packageTitle: "SPECIAL PACKAGE:",
        packageSubtitle: "Monthly Care Package",
        isSpecialPackage: true,
        description: "1 Grooming every month (valid 3 months)",
        time: "90",
        validFor: ["dog"],
        includes: [
            "Regular monthly grooming maintenance",
            "Priority booking slot",
        ],
        pricing: [
            { size: 'small', label: "Small dog", price: 'AED 660', salePrice: "AED 620" },
            { size: 'medium', label: "Medium dog", price: 'AED 810', salePrice: "AED 770" },
            { size: 'large', label: "Large dog", price: 'AED 990', salePrice: "AED 950" },
        ],
    },
    {
        packageId: "5",
        packageTitle: "SPECIAL PACKAGE:",
        packageSubtitle: "Puppy Care Package",
        isSpecialPackage: true,
        description: "Best for puppies under 6 months",
        time: "90",
        validFor: ["puppy"],
        includes: [
            "Includes 3 sessions",
            "Gentle bath & dry",
            "Nail trim",
            "Face & paw tidy",
        ],
        pricing: [
            { size: 'toy', label: "Puppy", price: "AED 360", salePrice: 'AED 362', },
        ],
    },
    {
        packageId: "6",
        packageTitle: "SPECIAL PACKAGE:",
        isSpecialPackage: true,
        packageSubtitle: "Cat Comfort Package",
        description: "Best for a premium look, long-coat breeds, shedding issues",
        time: "90",
        validFor: ["cat"],
        includes: [
            "Cat bath & blow dry",
            "De-shedding / dematting (if needed)",
            "Nail trim",
            "Ear cleaning",
        ],
        pricing: [
            { label: "Cat", price: "AED 310", salePrice: 'AED 270', },
        ],
    },
    {
        packageId: "7",
        packageTitle: "SPECIAL PACKAGE:",
        packageSubtitle: "Relief Oil Massage",
        description: "25 Minutes of Pure Relaxation",
        isSpecialPackage: true,
        time: "90",
        validFor: ["dog"],
        includes: [
            "Relaxing full body oil massage",
            "Stress & anxiety relief therapy",
        ],
        pricing: [
            { size: 'small', label: "Small dog", price: "AED 130", salePrice: 'AED 95' },
            { size: 'medium', label: "Medium dog", price: "AED 155", salePrice: 'AED 115' },
            { size: 'large', label: "Large dog", price: "AED 180", salePrice: 'AED 140', },
            { size: 'xl', label: "XL dog", price: "AED 200", salePrice: 'AED 160', },
        ],
    },
];

export const Petsections: Section[] = [
    {
        key: "description",
        title: "Pet Description",
        type: "text",
        data: "The Golden Retriever: A Legacy of Kindness & Joy Healthy and playful Golden Retriever puppy available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.Iconic Golden Coat: Lustrous double coat that ranges from light cream to deep honeycomb gold. Unmatched Temperament: Famously friendly, reliable, and trustworthy with humans and other pets.Highly Trainable: Exceptionally smart, eager-to-please breeds that excel in tracking, agility, and companionship.",
    },
    // {
    //     key: "instructions",
    //     title: "Care Instructions",
    //     type: "text",
    //     data: "Ensure a high-protein puppy diet spread out across 3-4 meals daily. Regular brushing twice a week is highly recommended to manage shedding and maintain healthy skin layers.",
    // },
    // {
    //     key: "faq",
    //     title: "Breed FAQ",
    //     type: "text",
    //     data: "Are they good apartment dogs? Yes, provided they receive at least 45 to 60 minutes of interactive play session outdoor training cycles every single day.",
    // },
    // {
    //     key: "verification",
    //     title: "Our Verification",
    //     type: "text",
    //     data: "We work exclusively with certified home breeders who prioritize animal welfare, socialization, and lineage clarity.",
    // },
];

export const userPets = [
    {
        id: "1",
        name: "Bruno",
        type: "dog",
        image: "https://images.unsplash.com/photo-1632674764208-bb420a102ace?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGxhcmdlJTIwZG9nfGVufDB8fDB8fHww",
        size: "large",
    },
];

export const offerDates = [
    {
        id: "1",
        date: 5,
        offer: "20% OFF",
    },
    {
        id: "2",
        date: 12,
        offer: "15% OFF",
    },
    {
        id: "3",
        date: 18,
        offer: "30% OFF",
    },
];

export const timeSlots = [
    {
        id: 1,
        time: "09:00 AM - 10:00 AM",
        slotsRemaining: 3,
    },
    {
        id: 2,
        time: "10:00 AM - 11:00 AM",
        slotsRemaining: 2,
    },
    {
        id: 3,
        time: "11:00 AM - 12:00 PM",
        slotsRemaining: 5,
    },
    {
        id: 4,
        time: "12:00 PM - 01:00 PM",
        slotsRemaining: 0,
    },
    {
        id: 5,
        time: "02:00 PM - 03:00 PM",
        slotsRemaining: 4,
    },
    {
        id: 6,
        time: "03:00 PM - 04:00 PM",
        slotsRemaining: 2,
    },
];

export const slots = [
    {
        id: 1,
        time: "09:00 AM - 09:30 AM",
    },
    {
        id: 2,
        time: "09:30 AM - 10:00 AM",
    },
    {
        id: 3,
        time: "10:00 AM - 10:30 AM",
    },
    {
        id: 4,
        time: "10:30 AM - 11:00 AM",
    },
    {
        id: 5,
        time: "11:00 AM - 11:30 AM",
    },
    {
        id: 6,
        time: "11:30 AM - 12:00 PM",
    },
    {
        id: 7,
        time: "12:00 PM - 12:30 PM",
    },
    {
        id: 8,
        time: "12:30 PM - 01:00 PM",
    },
    {
        id: 9,
        time: "01:00 PM - 01:30 PM",
    },
    {
        id: 10,
        time: "01:30 PM - 02:00 PM",
    },
    {
        id: 11,
        time: "02:00 PM - 02:30 PM",
    },
    {
        id: 12,
        time: "02:30 PM - 03:00 PM",
    },
    {
        id: 13,
        time: "03:00 PM - 03:30 PM",
    },
    {
        id: 14,
        time: "03:30 PM - 04:00 PM",
    },
    {
        id: 15,
        time: "04:00 PM - 04:30 PM",
    },
    {
        id: 16,
        time: "04:30 PM - 05:00 PM",
    },
];
export const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export const addOns = [
    {
        id: '1',
        icon: "https://plus.unsplash.com/premium_photo-1663957884429-ecb152a3b8b0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGRvZyUyMG5haWwlMjB0cmltfGVufDB8fDB8fHww",
        title: "Nail Trim",
        price: 70,
        description: "Keeps paws clean and comfortable",
    },
    {
        id: '2',
        icon: "https://images.unsplash.com/photo-1597603413826-cd1c06b05222?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZG9nJTIwdGVldGglMjBicnVzaGluZ3xlbnwwfHwwfHx8MA%3D%3D",
        title: "Teeth Brushing",
        price: 60,
        description: "Fresh breath and oral hygiene",
    },
    {
        id: '3',
        icon: "https://images.unsplash.com/photo-1632236705239-ac6f4908638d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGRvZyUyMGRlJTIwc2hlZGRpbmd8ZW58MHx8MHx8fDA%3D",
        title: "De-shedding",
        price: 90,
        description: "Reduces loose fur and shedding",
        badge: "Popular",
    },
    {
        id: '4',
        icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSS_373DVGoucnaKuGpoyF_infBzbLmMlK3LQ&s",
        title: "Flea & Tick Bath",
        price: 80,
        description: "Protection against fleas and ticks",
        badge: "Recommended",
    },
    {
        id: '5',
        icon: "https://images.unsplash.com/photo-1583336663277-620dc1996580?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZG9nJTIwc3R5bGluZ3xlbnwwfHwwfHx8MA%3D%3D",
        title: "Breed Styling",
        price: 120,
        description: "Customized styling for your breed",
    },
];

export const servicesItems = [
    {
        id: "1",
        name: "Grooming",
        image: "https://images.unsplash.com/photo-1611173622933-91942d394b04?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z3Jvb21pbmd8ZW58MHx8MHx8fDA%3D",
    },
    {
        id: "3",
        name: "Pet Training",
        image: "https://images.unsplash.com/photo-1596278852720-141ba859bbbf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHBldCUyMHRyYWluaW5nfGVufDB8fDB8fHww",
    },
    {
        id: "4",
        name: "Pet Taxi",
        image: "https://images.unsplash.com/photo-1521354465180-c1ceac1d709a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cGV0JTIwdGF4aXxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: "5",
        name: "Relocation",
        image: "https://images.unsplash.com/photo-1632236519667-29b4b78da232?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cGV0JTIwcmVsb2NhdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: "6",
        name: "Vet Care",
        image: "https://plus.unsplash.com/premium_photo-1661942274165-00cc8d55a93f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8dmV0JTIwY2FyZXxlbnwwfHwwfHx8MA%3D%3D",
    },
];

export const dogbreedOptionsMap: Option[] = [
    {
        id: "19",
        label: "+ Add Custom Breed",
        value: "custom",
    },
    { id: "1", label: "Golden Retriever", value: "Golden Retriever" },
    { id: "2", label: "Labrador Retriever", value: "Labrador Retriever" },
    { id: "3", label: "German Shepherd", value: "German Shepherd" },
    { id: "4", label: "Pug", value: "Pug" },
    { id: "5", label: "Beagle", value: "Beagle" },
    { id: "6", label: "Shih Tzu", value: "Shih Tzu" },
    { id: "7", label: "Rottweiler", value: "Rottweiler" },
    { id: "8", label: "Doberman", value: "Doberman" },
    { id: "9", label: "Siberian Husky", value: "Siberian Husky" },
    { id: "10", label: "Pomeranian", value: "Pomeranian" },
    { id: "11", label: "Dachshund", value: "Dachshund" },
    { id: "12", label: "Border Collie", value: "Border Collie" },
    { id: "13", label: "Great Dane", value: "Great Dane" },
    { id: "14", label: "Boxer", value: "Boxer" },
    { id: "15", label: "Chihuahua", value: "Chihuahua" },
    { id: "16", label: "Indian Spitz", value: "Indian Spitz" },
    { id: "17", label: "Rajapalayam", value: "Rajapalayam" },
    { id: "18", label: "Indie", value: "Indie" },
];

export const catbreedOptionsMap: Option[] = [
    {
        id: "100",
        label: "+ Add Custom Breed",
        value: "custom",
    },
    { id: "101", label: "Persian", value: "Persian" },
    { id: "102", label: "Siamese", value: "Siamese" },
    { id: "103", label: "Maine Coon", value: "Maine Coon" },
    { id: "104", label: "Bengal", value: "Bengal" },
    { id: "105", label: "British Shorthair", value: "British Shorthair" },
    { id: "106", label: "Ragdoll", value: "Ragdoll" },
    { id: "107", label: "Sphynx", value: "Sphynx" },
    { id: "108", label: "Russian Blue", value: "Russian Blue" },
    { id: "109", label: "Scottish Fold", value: "Scottish Fold" },
    { id: "110", label: "Himalayan", value: "Himalayan" },
    { id: "111", label: "Domestic Shorthair", value: "Domestic Shorthair" },
]

export const getBookingQuestions = (petType: string) => [
    {
        id: "2",
        key: "petImage",
        question: "",
        type: "image",
    },
    {
        id: '3',
        key: "petName",
        question: "What's your pet's name?",
        type: "text",
    },
    {
        id: "4",
        key: "breed",
        question: "Select Breed",
        type: "dropdown",
        options:
            petType === "dog"
                ? dogbreedOptionsMap
                : catbreedOptionsMap,
    },
    {
        id: '5',
        key: "gender",
        question: "Gender",
        type: "radio",
        options: [
            { id: "1", label: "Male" },
            { id: "2", label: "Female" },
        ],
    },
    {
        id: '6',
        key: "weight",
        question: "Weight (kg)",
        type: "radio",
        options: [
         
            { id: "small", label: "Small", value: "5-10 kg" },
            { id: "medium", label: "Medium", value: "10-25 kg" },
            { id: "large", label: "Large", value: "25-45 kg" },
            { id: "xl", label: "Extra Large", value: "Over 45 kg" },
        ],
    },
];

export const petfilterOptions: Option[] = [
    {
        id: "1",
        label: "Adopt Pets",
        value: "adopt",
    },
    {
        id: "2",
        label: "Buy Pets",
        value: "buy",
    },
    {
        id: "3",
        label: "Dogs",
        value: "dogs",
    },
    {
        id: "4",
        label: "Cats",
        value: "cats",
    },
];

// src/utils/Customer/CustomerData.ts

export interface PromoCardData {
    id: "relocation" | "vet_clinic";
    badgeText: string;
    titleLine1: string;
    titleLine2: string;
    description: string;
    buttonText: string;
    imageSrc: string;
    imageAlt: string;
}

export const promoCardsData: PromoCardData[] = [
    {
        id: "relocation",
        badgeText: "Relocation",
        titleLine1: "Moving to",
        titleLine2: "Abu Dhabi or Sharjah?",
        description: "Municipality approved pet transport with climate control and vet attendance.",
        buttonText: "Request DXB Quote",
        imageSrc: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=500",
        imageAlt: "Relocation service dog",
    },
    {
        id: "vet_clinic",
        badgeText: "Vet Clinic",
        titleLine1: "Premium",
        titleLine2: "Veterinary Care",
        description: "Expert veterinarians providing health checkups, vaccinations, emergency treatments and wellness care for pets across Dubai.",
        buttonText: "Book Appointment",
        imageSrc: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=500",
        imageAlt: "Vet Clinic dog",
    }
];

export const adminSections: SectionCard[] = [
    {
        id: "1",
        title: "Products",
        description: "Physical items & e-commerce stock.",
        icon: ShoppingBag,
    },
    {
        id: "2",
        title: "Services",
        description: "Digital offerings & bookings.",
        icon: Sparkles,
    },
    {
        id: "3",
        title: "Pets",
        description: "Classifications & pet types.",
        icon: Dog,
    },
];





export const demoOrders: ICustomerOrder[] = [
    {
        id: 1,
        orderNumber: "ORD-2026-88401",
        orderStatus: 1,
        paymentStatus: 3,
        totalAmount: 246,
        createdOn: "2026-06-16T15:24:00",
        productItems: [
            {
              id: 1,
              productName: "Royal Canine Health Pack",
              variantName: "15kg Adult",
              quantity: 1,
              totalPrice: 160,
              image:
                "https://petcornerdubai.com/uploads/cache/products/expiring-on-1306-josera-kitten-cat-dry-food-2kg/1773734070905639323-230x220.jpg",
            },
            {
              id: 2,
              productName: "Chew Ball",
              variantName: "Medium",
              quantity: 2,
              totalPrice: 80,
              image:
                "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8",
            },
        ],
        
        petItems: [
            {
              id: 101,
              productName: "Golden Retriever Puppy",
              variantName: "Male • 3 Months",
              quantity: 1,
              totalPrice: 18000,
              image:
                "https://images.unsplash.com/photo-1517849845537-4d257902454a?w=600",
            },
        ],
        
        serviceItems: [
            {
              id: 201,
              productName: "Premium Grooming",
              variantName: "Home Visit",
              quantity: 1,
              totalPrice: 999,
              image:
                "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=600",
            },
        ],
    },
    {
        id: 2,
        orderNumber: "ORD-2026-88402",
        orderStatus: 5,
        paymentStatus: 2,
        totalAmount: 425,
        createdOn: "2026-06-15T11:20:00",
        productItems: [
            {
              id: 3,
              productName: "Premium Dog Food",
              variantName: "10kg",
              quantity: 1,
              totalPrice: 425,
              image:
                "https://images.unsplash.com/photo-1696507398228-78f0368ddbc1?w=600&auto=format&fit=crop&q=60",
            },
        ],
        
        petItems: [],
        
        serviceItems: [],
    },
   
];

export const dummyPets: PetItems[] = [
    {
      petId: 1,
      petName: "Golden Retriever",
      breed: "Golden Retriever",
      gender: "Male",
      age: "3 Months",
      price: 2500,
      image: "https://placedog.net/500/500?id=1",
      images: [
        "https://placedog.net/500/500?id=1",
        "https://placedog.net/500/500?id=11",
        "https://placedog.net/500/500?id=21",
      ],
      location: "Dubai",
      vaccinated: true,
      available: true,
      pureBreed: true,
    },
    {
      petId: 2,
      petName: "Persian Cat",
      breed: "Persian",
      gender: "Female",
      age: "5 Months",
      price: 1800,
      image: "https://cataas.com/cat?width=500&height=500",
      images: [
        "https://cataas.com/cat?width=500&height=500",
        "https://cataas.com/cat/cute?width=500&height=500",
        "https://cataas.com/cat/says/Meow?width=500&height=500",
      ],
      location: "Dubai",
      vaccinated: true,
      available: true,
      pureBreed: true,
    },
    {
      petId: 3,
      petName: "Siberian Husky",
      breed: "Husky",
      gender: "Male",
      age: "7 Months",
      price: 3200,
      image: "https://placedog.net/500/500?id=3",
      images: [
        "https://placedog.net/500/500?id=3",
        "https://placedog.net/500/500?id=13",
        "https://placedog.net/500/500?id=23",
      ],
      location: "Abu Dhabi",
      vaccinated: true,
      available: true,
      pureBreed: true,
    },
    {
      petId: 4,
      petName: "British Shorthair",
      breed: "British Shorthair",
      gender: "Female",
      age: "4 Months",
      price: 2300,
      image: "https://cataas.com/cat?width=500&height=500&4",
      images: [
        "https://cataas.com/cat?width=500&height=500&4",
        "https://cataas.com/cat/cute?width=500&height=500&4",
      ],
      location: "Sharjah",
      vaccinated: true,
      available: false,
      pureBreed: true,
    },
    {
      petId: 5,
      petName: "Pomeranian",
      breed: "Pomeranian",
      gender: "Male",
      age: "2 Months",
      price: 2900,
      image: "https://placedog.net/500/500?id=5",
      images: [
        "https://placedog.net/500/500?id=5",
        "https://placedog.net/500/500?id=15",
        "https://placedog.net/500/500?id=25",
      ],
      location: "Dubai",
      vaccinated: false,
      available: true,
      pureBreed: true,
    },
    {
      petId: 6,
      petName: "Maine Coon",
      breed: "Maine Coon",
      gender: "Male",
      age: "6 Months",
      price: 3500,
      image: "https://cataas.com/cat?width=500&height=500&6",
      images: [
        "https://cataas.com/cat?width=500&height=500&6",
        "https://cataas.com/cat/cute?width=500&height=500&6",
      ],
      location: "Ajman",
      vaccinated: true,
      available: true,
      pureBreed: true,
    },
    {
      petId: 7,
      petName: "Shih Tzu",
      breed: "Shih Tzu",
      gender: "Female",
      age: "4 Months",
      price: 2700,
      image: "https://placedog.net/500/500?id=7",
      images: [
        "https://placedog.net/500/500?id=7",
        "https://placedog.net/500/500?id=17",
        "https://placedog.net/500/500?id=27",
      ],
      location: "Dubai",
      vaccinated: true,
      available: true,
      pureBreed: true,
    },
    {
      petId: 8,
      petName: "Ragdoll",
      breed: "Ragdoll",
      gender: "Female",
      age: "3 Months",
      price: 3100,
      image: "https://cataas.com/cat?width=500&height=500&8",
      images: [
        "https://cataas.com/cat?width=500&height=500&8",
        "https://cataas.com/cat/cute?width=500&height=500&8",
      ],
      location: "Dubai",
      vaccinated: false,
      available: true,
      pureBreed: true,
    },
    {
      petId: 9,
      petName: "Labrador Retriever",
      breed: "Labrador",
      gender: "Male",
      age: "5 Months",
      price: 2800,
      image: "https://placedog.net/500/500?id=9",
      images: [
        "https://placedog.net/500/500?id=9",
        "https://placedog.net/500/500?id=19",
        "https://placedog.net/500/500?id=29",
      ],
      location: "Al Ain",
      vaccinated: true,
      available: true,
      pureBreed: false,
    },
    {
      petId: 10,
      petName: "Scottish Fold",
      breed: "Scottish Fold",
      gender: "Female",
      age: "8 Months",
      price: 3400,
      image: "https://cataas.com/cat?width=500&height=500&10",
      images: [
        "https://cataas.com/cat?width=500&height=500&10",
        "https://cataas.com/cat/cute?width=500&height=500&10",
      ],
      location: "Dubai",
      vaccinated: true,
      available: false,
      pureBreed: true,
    },
  ];

  export interface CalendarService {
    id: number;
    orderId: string;
    customerName: string;
    customerPhone: string;
    petName: string;
    petType: string;
    serviceName: string;
    serviceCategory:
      | "Grooming"
      | "Training"
      | "Veterinary"
      | "Boarding"
      | "Walking"
      | "Pet Care"
      | "Spa";
  
    employeeName: string;
    serviceDate: string;
    serviceTime: string;
    duration: string;
    amount: number;
    paymentStatus: "Paid" | "Pending";
    status: "Upcoming" | "Completed" | "Cancelled";
    notes: string;
  }

  export const calendarServices: CalendarService[] = [
    // =========================================================
    // JULY 2 - LIGHT DAY
    // =========================================================
  
    {
      id: 1,
      orderId: "ORD-1001",
      customerName: "Ahmed Al Mansoori",
      customerPhone: "+971 50 234 7812",
      petName: "Max",
      petType: "Golden Retriever",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-02",
      serviceTime: "09:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 180,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Regular customer. Use sensitive skin shampoo.",
    },
    {
      id: 2,
      orderId: "ORD-1002",
      customerName: "Fatima Al Nuaimi",
      customerPhone: "+971 55 821 3490",
      petName: "Luna",
      petType: "Persian Cat",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-02",
      serviceTime: "11:00 AM",
      duration: "1 Hour",
      amount: 140,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Remove minor matting around the neck area.",
    },
    {
      id: 3,
      orderId: "ORD-1003",
      customerName: "Omar Hassan",
      customerPhone: "+971 52 456 9012",
      petName: "Rocky",
      petType: "German Shepherd",
      serviceName: "Basic Obedience Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-02",
      serviceTime: "04:30 PM",
      duration: "1 Hour",
      amount: 220,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Focus on leash control and recall commands.",
    },
  
    // =========================================================
    // JULY 4 - BUSY GROOMING DAY
    // =========================================================
  
    {
      id: 4,
      orderId: "ORD-1004",
      customerName: "Mohammed Al Falasi",
      customerPhone: "+971 50 675 1209",
      petName: "Buddy",
      petType: "Labrador Retriever",
      serviceName: "Bath & Blow Dry",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-04",
      serviceTime: "08:30 AM",
      duration: "1 Hour",
      amount: 120,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Heavy shedding. Add de-shedding treatment.",
    },
    {
      id: 5,
      orderId: "ORD-1005",
      customerName: "Layla Ibrahim",
      customerPhone: "+971 56 321 8845",
      petName: "Coco",
      petType: "Pomeranian",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-04",
      serviceTime: "09:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 165,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Teddy bear haircut requested.",
    },
    {
      id: 6,
      orderId: "ORD-1006",
      customerName: "James Anderson",
      customerPhone: "+971 58 742 1134",
      petName: "Charlie",
      petType: "Beagle",
      serviceName: "Nail Trimming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-04",
      serviceTime: "10:00 AM",
      duration: "30 Minutes",
      amount: 45,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Pet gets anxious during nail trimming.",
    },
    {
      id: 7,
      orderId: "ORD-1007",
      customerName: "Aisha Rahman",
      customerPhone: "+971 50 889 3471",
      petName: "Milo",
      petType: "British Shorthair",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-04",
      serviceTime: "11:30 AM",
      duration: "1 Hour",
      amount: 135,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Clean ears and trim nails.",
    },
    {
      id: 8,
      orderId: "ORD-1008",
      customerName: "Daniel Wilson",
      customerPhone: "+971 54 219 7756",
      petName: "Bella",
      petType: "French Bulldog",
      serviceName: "Pet Spa Treatment",
      serviceCategory: "Spa",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-04",
      serviceTime: "01:30 PM",
      duration: "1 Hour 30 Minutes",
      amount: 250,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Include paw balm and coat conditioning.",
    },
    {
      id: 9,
      orderId: "ORD-1009",
      customerName: "Noura Al Suwaidi",
      customerPhone: "+971 55 487 2361",
      petName: "Simba",
      petType: "Maine Coon",
      serviceName: "De-shedding Treatment",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-04",
      serviceTime: "03:00 PM",
      duration: "1 Hour",
      amount: 160,
      paymentStatus: "Pending",
      status: "Completed",
      notes: "Heavy seasonal shedding.",
    },
  
    // =========================================================
    // JULY 5 - MIXED SERVICES
    // =========================================================
  
    {
      id: 10,
      orderId: "ORD-1010",
      customerName: "Khalid Al Marri",
      customerPhone: "+971 50 768 4432",
      petName: "Zeus",
      petType: "Rottweiler",
      serviceName: "Behavior Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-05",
      serviceTime: "08:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 300,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Work on social behavior around other dogs.",
    },
    {
      id: 11,
      orderId: "ORD-1011",
      customerName: "Emma Thompson",
      customerPhone: "+971 58 365 9081",
      petName: "Daisy",
      petType: "Shih Tzu",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-05",
      serviceTime: "09:30 AM",
      duration: "1 Hour 30 Minutes",
      amount: 170,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Short summer cut requested.",
    },
    {
      id: 12,
      orderId: "ORD-1012",
      customerName: "Hamad Al Shamsi",
      customerPhone: "+971 52 777 4510",
      petName: "Oscar",
      petType: "Golden Retriever",
      serviceName: "Veterinary Consultation",
      serviceCategory: "Veterinary",
      employeeName: "Dr. Emma Wilson",
      serviceDate: "2026-07-05",
      serviceTime: "10:00 AM",
      duration: "30 Minutes",
      amount: 200,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Routine skin irritation consultation.",
    },
    {
      id: 13,
      orderId: "ORD-1013",
      customerName: "Sophia Williams",
      customerPhone: "+971 56 990 1287",
      petName: "Ruby",
      petType: "Cocker Spaniel",
      serviceName: "Bath & Blow Dry",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-05",
      serviceTime: "12:30 PM",
      duration: "1 Hour",
      amount: 125,
      paymentStatus: "Pending",
      status: "Completed",
      notes: "Customer will pay at pickup.",
    },
    {
      id: 14,
      orderId: "ORD-1014",
      customerName: "Yousef Abdullah",
      customerPhone: "+971 50 346 7854",
      petName: "Bruno",
      petType: "Boxer",
      serviceName: "Dog Walking",
      serviceCategory: "Walking",
      employeeName: "Jessica Harris",
      serviceDate: "2026-07-05",
      serviceTime: "05:30 PM",
      duration: "45 Minutes",
      amount: 75,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Evening walk. Avoid high-intensity running.",
    },
  
    // =========================================================
    // JULY 7 - QUIET DAY
    // =========================================================
  
    {
      id: 15,
      orderId: "ORD-1015",
      customerName: "Mariam Al Mazrouei",
      customerPhone: "+971 55 671 2098",
      petName: "Nala",
      petType: "Bengal Cat",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-07",
      serviceTime: "10:30 AM",
      duration: "1 Hour",
      amount: 145,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Regular monthly grooming appointment.",
    },
    {
      id: 16,
      orderId: "ORD-1016",
      customerName: "Ryan Cooper",
      customerPhone: "+971 58 443 7761",
      petName: "Cooper",
      petType: "Border Collie",
      serviceName: "Advanced Obedience Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-07",
      serviceTime: "04:00 PM",
      duration: "1 Hour 30 Minutes",
      amount: 320,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Continue off-leash recall exercises.",
    },
  
    // =========================================================
    // JULY 10 - BUSY DAY
    // =========================================================
  
    {
      id: 17,
      orderId: "ORD-1017",
      customerName: "Ali Al Ketbi",
      customerPhone: "+971 50 921 3376",
      petName: "Leo",
      petType: "German Shepherd",
      serviceName: "Bath & De-shedding",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-10",
      serviceTime: "08:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 190,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Heavy shedding treatment required.",
    },
    {
      id: 18,
      orderId: "ORD-1018",
      customerName: "Rachel Green",
      customerPhone: "+971 56 742 8901",
      petName: "Teddy",
      petType: "Toy Poodle",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-10",
      serviceTime: "09:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 175,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Puppy cut with rounded face styling.",
    },
    {
      id: 19,
      orderId: "ORD-1019",
      customerName: "Saeed Al Qasimi",
      customerPhone: "+971 52 388 4512",
      petName: "Thor",
      petType: "Doberman",
      serviceName: "Behavior Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-10",
      serviceTime: "10:30 AM",
      duration: "1 Hour",
      amount: 250,
      paymentStatus: "Pending",
      status: "Completed",
      notes: "Focus on visitor aggression management.",
    },
    {
      id: 20,
      orderId: "ORD-1020",
      customerName: "Reem Hassan",
      customerPhone: "+971 55 209 7634",
      petName: "Mimi",
      petType: "Persian Cat",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-10",
      serviceTime: "11:00 AM",
      duration: "1 Hour",
      amount: 140,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Minor matting on rear coat.",
    },
    {
      id: 21,
      orderId: "ORD-1021",
      customerName: "Thomas Martin",
      customerPhone: "+971 58 901 2476",
      petName: "Bailey",
      petType: "Labrador Retriever",
      serviceName: "Veterinary Consultation",
      serviceCategory: "Veterinary",
      employeeName: "Dr. Emma Wilson",
      serviceDate: "2026-07-10",
      serviceTime: "02:00 PM",
      duration: "30 Minutes",
      amount: 200,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Follow-up consultation for ear infection.",
    },
    {
      id: 22,
      orderId: "ORD-1022",
      customerName: "Hessa Al Ali",
      customerPhone: "+971 50 467 8213",
      petName: "Snow",
      petType: "Samoyed",
      serviceName: "Premium Pet Spa",
      serviceCategory: "Spa",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-10",
      serviceTime: "03:30 PM",
      duration: "2 Hours",
      amount: 350,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Full coat conditioning and de-shedding package.",
    },
  
    // =========================================================
    // JULY 14 - CURRENT / MIXED STATUS DAY
    // =========================================================
  
    {
      id: 23,
      orderId: "ORD-1023",
      customerName: "Abdullah Al Zaabi",
      customerPhone: "+971 50 785 3321",
      petName: "Ace",
      petType: "Husky",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-14",
      serviceTime: "08:30 AM",
      duration: "1 Hour 30 Minutes",
      amount: 210,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "De-shedding treatment included.",
    },
    {
      id: 24,
      orderId: "ORD-1024",
      customerName: "Sarah Collins",
      customerPhone: "+971 58 672 1109",
      petName: "Lucy",
      petType: "Cavalier King Charles Spaniel",
      serviceName: "Bath & Blow Dry",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-14",
      serviceTime: "10:00 AM",
      duration: "1 Hour",
      amount: 130,
      paymentStatus: "Paid",
      status: "Completed",
      notes: "Use floral pet-safe conditioner.",
    },
    {
      id: 25,
      orderId: "ORD-1025",
      customerName: "Faisal Al Hammadi",
      customerPhone: "+971 52 441 9087",
      petName: "Diesel",
      petType: "Rottweiler",
      serviceName: "Advanced Dog Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-14",
      serviceTime: "11:30 AM",
      duration: "1 Hour 30 Minutes",
      amount: 320,
      paymentStatus: "Pending",
      status: "Upcoming",
      notes: "Third session of the advanced training package.",
    },
    {
      id: 26,
      orderId: "ORD-1026",
      customerName: "Noor Ahmed",
      customerPhone: "+971 55 890 3367",
      petName: "Oreo",
      petType: "British Shorthair",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-14",
      serviceTime: "01:00 PM",
      duration: "1 Hour",
      amount: 140,
      paymentStatus: "Pending",
      status: "Upcoming",
      notes: "First grooming appointment with PetLand.",
    },
    {
      id: 27,
      orderId: "ORD-1027",
      customerName: "Mark Taylor",
      customerPhone: "+971 56 723 5512",
      petName: "Jack",
      petType: "Jack Russell Terrier",
      serviceName: "Nail Trimming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-14",
      serviceTime: "02:30 PM",
      duration: "30 Minutes",
      amount: 45,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Walk-in appointment converted to booking.",
    },
  
    // =========================================================
    // JULY 16 - CANCELLATION + REGULAR BOOKINGS
    // =========================================================
  
    {
      id: 28,
      orderId: "ORD-1028",
      customerName: "Sultan Al Balushi",
      customerPhone: "+971 50 634 7721",
      petName: "Shadow",
      petType: "Belgian Malinois",
      serviceName: "Behavior Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-16",
      serviceTime: "08:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 300,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Focus on impulse control exercises.",
    },
    {
      id: 29,
      orderId: "ORD-1029",
      customerName: "Amelia Brown",
      customerPhone: "+971 58 390 6612",
      petName: "Rosie",
      petType: "Maltese",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-16",
      serviceTime: "09:30 AM",
      duration: "1 Hour 30 Minutes",
      amount: 165,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Maintain medium coat length.",
    },
    {
      id: 30,
      orderId: "ORD-1030",
      customerName: "Maha Al Mansouri",
      customerPhone: "+971 55 742 8103",
      petName: "Ginger",
      petType: "Persian Cat",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-16",
      serviceTime: "11:00 AM",
      duration: "1 Hour",
      amount: 140,
      paymentStatus: "Pending",
      status: "Cancelled",
      notes: "Customer cancelled due to pet illness.",
    },
    {
      id: 31,
      orderId: "ORD-1031",
      customerName: "Chris Evans",
      customerPhone: "+971 56 338 2190",
      petName: "Finn",
      petType: "Golden Retriever",
      serviceName: "Pet Spa Treatment",
      serviceCategory: "Spa",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-16",
      serviceTime: "01:00 PM",
      duration: "2 Hours",
      amount: 300,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Birthday spa package requested by owner.",
    },
  
    // =========================================================
    // JULY 18 - WEEKEND / VERY BUSY
    // =========================================================
  
    {
      id: 32,
      orderId: "ORD-1032",
      customerName: "Rashid Al Maktoum",
      customerPhone: "+971 50 231 8847",
      petName: "Bolt",
      petType: "Siberian Husky",
      serviceName: "Bath & De-shedding",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-18",
      serviceTime: "08:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 210,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Heavy summer shedding.",
    },
    {
      id: 33,
      orderId: "ORD-1033",
      customerName: "Emily Watson",
      customerPhone: "+971 58 781 4492",
      petName: "Molly",
      petType: "Toy Poodle",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-18",
      serviceTime: "08:30 AM",
      duration: "1 Hour 30 Minutes",
      amount: 175,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Teddy bear styling requested.",
    },
    {
      id: 34,
      orderId: "ORD-1034",
      customerName: "Hind Al Marzouqi",
      customerPhone: "+971 55 467 9921",
      petName: "Misty",
      petType: "Ragdoll Cat",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-18",
      serviceTime: "10:00 AM",
      duration: "1 Hour",
      amount: 145,
      paymentStatus: "Pending",
      status: "Upcoming",
      notes: "Brush-out and sanitary trim.",
    },
    {
      id: 35,
      orderId: "ORD-1035",
      customerName: "George Miller",
      customerPhone: "+971 56 442 7810",
      petName: "Duke",
      petType: "Great Dane",
      serviceName: "Veterinary Consultation",
      serviceCategory: "Veterinary",
      employeeName: "Dr. Emma Wilson",
      serviceDate: "2026-07-18",
      serviceTime: "10:30 AM",
      duration: "45 Minutes",
      amount: 250,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Joint health consultation.",
    },
    {
      id: 36,
      orderId: "ORD-1036",
      customerName: "Salem Al Kaabi",
      customerPhone: "+971 50 891 6634",
      petName: "Bruno",
      petType: "Cane Corso",
      serviceName: "Behavior Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-18",
      serviceTime: "12:00 PM",
      duration: "1 Hour 30 Minutes",
      amount: 320,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Socialization training session.",
    },
    {
      id: 37,
      orderId: "ORD-1037",
      customerName: "Olivia Parker",
      customerPhone: "+971 58 331 7209",
      petName: "Lily",
      petType: "Shih Tzu",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-18",
      serviceTime: "01:30 PM",
      duration: "1 Hour 30 Minutes",
      amount: 170,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Short summer cut and nail trimming.",
    },
    {
      id: 38,
      orderId: "ORD-1038",
      customerName: "Dana Al Hashmi",
      customerPhone: "+971 52 720 1145",
      petName: "Kiwi",
      petType: "Pomeranian",
      serviceName: "Premium Pet Spa",
      serviceCategory: "Spa",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-18",
      serviceTime: "03:00 PM",
      duration: "2 Hours",
      amount: 320,
      paymentStatus: "Pending",
      status: "Upcoming",
      notes: "Coat conditioning and paw treatment.",
    },
  
    // =========================================================
    // JULY 21 - BOARDING BOOKINGS
    // =========================================================
  
    {
      id: 39,
      orderId: "ORD-1039",
      customerName: "Mohammed Saeed",
      customerPhone: "+971 50 612 3389",
      petName: "Rex",
      petType: "German Shepherd",
      serviceName: "Dog Boarding",
      serviceCategory: "Boarding",
      employeeName: "James Thomas",
      serviceDate: "2026-07-21",
      serviceTime: "08:00 AM",
      duration: "5 Days",
      amount: 750,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Owner travelling. Feeding schedule provided.",
    },
    {
      id: 40,
      orderId: "ORD-1040",
      customerName: "Jennifer Scott",
      customerPhone: "+971 58 234 8907",
      petName: "Chloe",
      petType: "British Shorthair",
      serviceName: "Cat Boarding",
      serviceCategory: "Boarding",
      employeeName: "James Thomas",
      serviceDate: "2026-07-21",
      serviceTime: "09:30 AM",
      duration: "7 Days",
      amount: 840,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Indoor cat. Keep in quiet boarding section.",
    },
    {
      id: 41,
      orderId: "ORD-1041",
      customerName: "Tariq Al Qasimi",
      customerPhone: "+971 55 672 4431",
      petName: "Ghost",
      petType: "Siberian Husky",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-21",
      serviceTime: "11:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 210,
      paymentStatus: "Pending",
      status: "Upcoming",
      notes: "Full de-shedding treatment required.",
    },
  
    // =========================================================
    // JULY 25 - BUSY WEEKEND
    // =========================================================
  
    {
      id: 42,
      orderId: "ORD-1042",
      customerName: "Ahmed Al Ameri",
      customerPhone: "+971 50 442 8701",
      petName: "King",
      petType: "Golden Retriever",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-25",
      serviceTime: "08:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 185,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Regular monthly grooming.",
    },
    {
      id: 43,
      orderId: "ORD-1043",
      customerName: "Sophie Turner",
      customerPhone: "+971 58 621 9074",
      petName: "Archie",
      petType: "Cocker Spaniel",
      serviceName: "Bath & Blow Dry",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-25",
      serviceTime: "09:00 AM",
      duration: "1 Hour",
      amount: 125,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Ear cleaning requested.",
    },
    {
      id: 44,
      orderId: "ORD-1044",
      customerName: "Khalifa Al Nuaimi",
      customerPhone: "+971 52 891 7742",
      petName: "Hunter",
      petType: "Belgian Malinois",
      serviceName: "Advanced Dog Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-25",
      serviceTime: "10:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 320,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Advanced obedience package session four.",
    },
    {
      id: 45,
      orderId: "ORD-1045",
      customerName: "Mary Johnson",
      customerPhone: "+971 56 338 9045",
      petName: "Peanut",
      petType: "Chihuahua",
      serviceName: "Nail Trimming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-25",
      serviceTime: "11:30 AM",
      duration: "30 Minutes",
      amount: 45,
      paymentStatus: "Pending",
      status: "Upcoming",
      notes: "Pet is nervous around grooming equipment.",
    },
    {
      id: 46,
      orderId: "ORD-1046",
      customerName: "Latifa Al Muhairi",
      customerPhone: "+971 55 789 2013",
      petName: "Pearl",
      petType: "Persian Cat",
      serviceName: "Cat Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-25",
      serviceTime: "01:00 PM",
      duration: "1 Hour",
      amount: 145,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Full brush-out and nail trimming.",
    },
    {
      id: 47,
      orderId: "ORD-1047",
      customerName: "Robert Harris",
      customerPhone: "+971 58 773 4520",
      petName: "Murphy",
      petType: "Labrador Retriever",
      serviceName: "Pet Spa Treatment",
      serviceCategory: "Spa",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-25",
      serviceTime: "02:30 PM",
      duration: "2 Hours",
      amount: 300,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Full spa and coat conditioning package.",
    },
  
    // =========================================================
    // JULY 28 - CANCELLED DAY MIX
    // =========================================================
  
    {
      id: 48,
      orderId: "ORD-1048",
      customerName: "Nasser Al Shamsi",
      customerPhone: "+971 50 345 8821",
      petName: "Storm",
      petType: "Husky",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Sarah Johnson",
      serviceDate: "2026-07-28",
      serviceTime: "09:00 AM",
      duration: "1 Hour 30 Minutes",
      amount: 210,
      paymentStatus: "Pending",
      status: "Cancelled",
      notes: "Customer requested appointment rescheduling.",
    },
    {
      id: 49,
      orderId: "ORD-1049",
      customerName: "Grace Wilson",
      customerPhone: "+971 58 401 7793",
      petName: "Poppy",
      petType: "Maltese",
      serviceName: "Full Grooming",
      serviceCategory: "Grooming",
      employeeName: "Michael Brown",
      serviceDate: "2026-07-28",
      serviceTime: "10:30 AM",
      duration: "1 Hour 30 Minutes",
      amount: 165,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Maintain long coat with light trimming.",
    },
    {
      id: 50,
      orderId: "ORD-1050",
      customerName: "Majid Al Ketbi",
      customerPhone: "+971 52 680 2291",
      petName: "Titan",
      petType: "Cane Corso",
      serviceName: "Behavior Training",
      serviceCategory: "Training",
      employeeName: "David Miller",
      serviceDate: "2026-07-28",
      serviceTime: "04:00 PM",
      duration: "1 Hour 30 Minutes",
      amount: 320,
      paymentStatus: "Paid",
      status: "Upcoming",
      notes: "Continue controlled socialization exercises.",
    },
    {
        id: 51,
        orderId: "ORD-1010",
        customerName: "Khalid Al Marri",
        customerPhone: "+971 50 768 4432",
        petName: "Zeus",
        petType: "Rottweiler",
        serviceName: "Behavior Training",
        serviceCategory: "Training",
        employeeName: "David Miller",
        serviceDate: "2026-07-05",
        serviceTime: "08:00 AM",
        duration: "1 Hour 30 Minutes",
        amount: 300,
        paymentStatus: "Paid",
        status: "Completed",
        notes: "Work on social behavior around other dogs.",
      },
      {
        id: 52,
        orderId: "ORD-1010",
        customerName: "Khalid Al Marri",
        customerPhone: "+971 50 768 4432",
        petName: "Zeus",
        petType: "Rottweiler",
        serviceName: "Behavior Training",
        serviceCategory: "Training",
        employeeName: "David Miller",
        serviceDate: "2026-07-05",
        serviceTime: "08:00 AM",
        duration: "1 Hour 30 Minutes",
        amount: 300,
        paymentStatus: "Paid",
        status: "Completed",
        notes: "Work on social behavior around other dogs.",
      },
      {
        id: 52,
        orderId: "ORD-1010",
        customerName: "Khalid Al Marri",
        customerPhone: "+971 50 768 4432",
        petName: "Zeus",
        petType: "Rottweiler",
        serviceName: "Behavior Training",
        serviceCategory: "Training",
        employeeName: "David Miller",
        serviceDate: "2026-07-05",
        serviceTime: "08:00 AM",
        duration: "1 Hour 30 Minutes",
        amount: 300,
        paymentStatus: "Paid",
        status: "Completed",
        notes: "Work on social behavior around other dogs.",
      },
      {
        id: 52,
        orderId: "ORD-1010",
        customerName: "Khalid Al Marri",
        customerPhone: "+971 50 768 4432",
        petName: "Zeus",
        petType: "Rottweiler",
        serviceName: "Behavior Training",
        serviceCategory: "Training",
        employeeName: "David Miller",
        serviceDate: "2026-07-05",
        serviceTime: "08:00 AM",
        duration: "1 Hour 30 Minutes",
        amount: 300,
        paymentStatus: "Paid",
        status: "Completed",
        notes: "Work on social behavior around other dogs.",
      },
      {
        id: 52,
        orderId: "ORD-1010",
        customerName: "Khalid Al Marri",
        customerPhone: "+971 50 768 4432",
        petName: "Zeus",
        petType: "Rottweiler",
        serviceName: "Behavior Training",
        serviceCategory: "Training",
        employeeName: "David Miller",
        serviceDate: "2026-07-05",
        serviceTime: "08:00 AM",
        duration: "1 Hour 30 Minutes",
        amount: 300,
        paymentStatus: "Paid",
        status: "Completed",
        notes: "Work on social behavior around other dogs.",
      },
      {
        id: 52,
        orderId: "ORD-1010",
        customerName: "Khalid Al Marri",
        customerPhone: "+971 50 768 4432",
        petName: "Zeus",
        petType: "Rottweiler",
        serviceName: "Behavior Training",
        serviceCategory: "Training",
        employeeName: "David Miller",
        serviceDate: "2026-07-05",
        serviceTime: "08:00 AM",
        duration: "1 Hour 30 Minutes",
        amount: 300,
        paymentStatus: "Paid",
        status: "Completed",
        notes: "Work on social behavior around other dogs.",
      },
      
  ];